/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <karolpawlak.giap@gmail.com>, October 2020
 */

/* eslint-disable max-len */
/* flow-disable */

import { Col, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import { multiPolygon, intersect, buffer, polygon, point } from '@turf/turf';
import { read as readShapefile } from 'shapefile';
import Select from 'react-select';
import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import { PanelStyle } from '../../constants';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { PersonalDataContainer, DecisionContainer } from '../../containers';
import AttachmentsPanel from '../../components/AttachmentsPanel';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import _ from 'lodash';
import s from './EServices.css';
import {
  standardMaterialsOptions,
  kartoMaterialsOptions,
  customMaterialsOptions,
  categoriesDict
}
  from './dicts';
import v from './validators';
import fetch from '../../core/fetch/fetch.server';
import waiting from '../../routes/eserviceSummary/waiting-wheel-300x300.gif';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../components/utils/utils';

const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;

const reservationText = <p style={{ color: 'red' }}><b>Uwaga:</b> wybrane arkusze mapy drukowanej, poligraficznej zostaną zarezerwowane na 14 dni od dnia złożenia wniosku. Aby wniosek został zrealizowany, należy opłacić go w wyznaczonym terminie, w innym przypadku wniosek zostanie anulowany.</p>;

const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
  float: 'right',
};

const helpLinkDict = {
  UdostepnienieMaterialow: 'https://e-spdp.pl/static/instrukcje/UdostepnienieMaterialow.pdf',
  UdostepnienieMaterialowPublicznych: 'https://e-spdp.pl/static/instrukcje/UdostepnienieMaterialowPublicznych.pdf',
  UdostepnienieMaterialowBezLogowania: 'https://e-spdp.pl/static/instrukcje/UdostepnienieMaterialowBezLogowania.pdf',
}

const contactDict = {
  firstName: {
    label: 'Imię',
    editable: true,
  },
  lastName: {
    label: 'Nazwisko',
    editable: true,
  },
  PhoneNumber: {
    label: 'Telefon',
    editable: true,
  },
  email: {
    label: 'Email',
    editable: true,
  },
};

const publicDict = {
  zadaniePubliczne: {
    label: 'Zadanie publiczne',
    editable: true,
  },
  podstawaPrawna: {
    label: 'Podstawa prawna',
    editable: true,
  },
  okresUdostepnienia: {
    label: 'Okres uprawnienia do materiału do*',
    editable: true,
    type: 'DatePicker',
  },
};

const areaSelectionOptions = [
  {
    label: 'jednostki podziału terytorialnego kraju',
    value: 'jednostki podziału terytorialnego kraju',
    state: 'areaSelection',
  },
  {
    label: 'godło arkusza mapy',
    value: 'godło arkusza mapy',
    state: 'areaSelection',
  },
  {
    label: 'obszar określony w załączniku',
    value: 'obszar określony w załączniku',
    state: 'areaSelection',
  },
  {
    label: 'współrzędne wielokąta (poligonu)',
    value: 'współrzędne wielokąta (poligonu)',
    state: 'areaSelection',
  },
];

const areaSelectionOptions2 = [
  {
    label: 'jednostki podziału terytorialnego kraju',
    value: 'jednostki podziału terytorialnego kraju',
    state: 'areaSelection',
  },
  {
    label: 'obszar określony w załączniku',
    value: 'obszar określony w załączniku',
    state: 'areaSelection',
  },
  {
    label: 'współrzędne wielokąta (poligonu)',
    value: 'współrzędne wielokąta (poligonu)',
    state: 'areaSelection',
  },
];

const payableSharingReasonOptions = [
  {
    label: 'dla potrzeb własnych niezwiązanych z działalnością gospodarczą, bez prawa publikacji w sieci Internet',
    value: 'dla potrzeb własnych niezwiązanych z działalnością gospodarczą, bez prawa publikacji w sieci Internet',
    state: 'sharingReason',
  },
  {
    label: 'dla dowolnych potrzeb',
    value: 'dla dowolnych potrzeb',
    state: 'sharingReason',
  },
];

export const freeSharingReasonOptions = [
  {
    label: 'na cele edukacyjne jednostkom organizacyjnym wchodzącym w skład systemu oświaty, uczelniom, podmiotom pożytku publicznego',
    value: 'na cele edukacyjne jednostkom organizacyjnym wchodzącym w skład systemu oświaty, uczelniom, podmiotom pożytku publicznego',
    state: 'sharingReason',
  },
  {
    label: 'w celu prowadzenia badań naukowych/prac rozwojowych',
    value: 'w celu prowadzenia badań naukowych/prac rozwojowych',
    state: 'sharingReason',
  },
  {
    label: 'w celu realizacji ustawowych zadań w zakresie ochrony bezpieczeństwa wewnętrznego państwa i jego porządku konstytucyjnego – służbom specjalnym',
    value: 'w celu realizacji ustawowych zadań w zakresie ochrony bezpieczeństwa wewnętrznego państwa i jego porządku konstytucyjnego – służbom specjalnym',
    state: 'sharingReason',
  },
  {
    label: 'w celu realizacji zadań w zakresie obronności państwa – Ministrowi Obrony Narodowej',
    value: 'w celu realizacji zadań w zakresie obronności państwa – Ministrowi Obrony Narodowej',
    state: 'sharingReason',
  },
];

const freeSharingReasonValues = [
  'na cele edukacyjne jednostkom organizacyjnym wchodzącym w skład systemu oświaty, uczelniom, podmiotom pożytku publicznego',
  'w celu prowadzenia badań naukowych/prac rozwojowych',
  'w celu realizacji ustawowych zadań w zakresie ochrony bezpieczeństwa wewnętrznego państwa i jego porządku konstytucyjnego – służbom specjalnym',
  'w celu realizacji zadań w zakresie obronności państwa – Ministrowi Obrony Narodowej',
];

const freeSharingMethodValues = [
  'wektorowa',
  'rastrowa',
];

const freeDeliverygMethodValues = [
  'Udostępnienie na serwerze FTP WODGiK',
  'Wysyłka na wskazany adres e-mail',
];

const sharingMethodOptions = [
  {
    label: 'wektorowa',
    value: 'wektorowa',
    state: 'sharingMethod',
  },
  {
    label: 'rastrowa',
    value: 'rastrowa',
    state: 'sharingMethod',
  },
];

const sharingMethodOptions2 = [
  {
    label: 'drukowana',
    value: 'drukowana',
    state: 'sharingMethod',
  },
];

const printedMethodsOptions = [
  {
    label: 'ploterowy wydruk kolorowy',
    value: 'kolorowy',
    state: 'printedSharingMethod',
  },
  {
    label: 'ploterowy wydruk czarno-biały',
    value: 'czarno-biały',
    state: 'printedSharingMethod',
  },
  {
    label: 'druk poligraficzny',
    value: 'druk poligraficzny',
    state: 'printedSharingMethod',
  },
];

const printedMethodDetailsOptions = [
  {
    label: 'mapa płaska',
    value: 'mapa płaska',
    state: 'printedSharingMethodDetails',
  },
  {
    label: 'mapa składana',
    value: 'mapa składana',
    state: 'printedSharingMethodDetails',
  },
]

const printedSharingMethods = [
  'drukowana',
];

const printedDeliverygMethodValues = [
  'Odbiór osobisty',
  'Wysyłka pod wskazany adres',
];
const selfPickup = 'Odbiór osobisty';
const deliveryAddress = 'Wysyłka pod wskazany adres';
const deliveryAddressEmail = 'Wysyłka na wskazany adres e-mail';
const deliveryAddressOtherOption = 'inny';

const deliveryAddressOptions = [
  {
    label: 'jak w nagłówku',
    value: 'jak w nagłówku',
    state: 'deliveryAddress',
  },
  {
    label: 'inny',
    value: 'inny',
    state: 'deliveryAddress',
  },
];

const deliverygMethodOptions = [
  {
    label: 'odbiór osobisty',
    value: 'Odbiór osobisty',
    state: 'deliveryMethod',
  },
  {
    label: 'wysyłka pod wskazany adres',
    value: 'Wysyłka pod wskazany adres',
    state: 'deliveryMethod',
  },
  {
    label: 'udostępnienie na serwerze FTP WODGiK',
    value: 'Udostępnienie na serwerze FTP WODGiK',
    state: 'deliveryMethod',
  },
  {
    label: 'wysyłka na wskazany adres e-mail',
    value: 'Wysyłka na wskazany adres e-mail',
    state: 'deliveryMethod',
  },
];

const publicDeliverygMethodOptions = [
  {
    label: 'udostępnienie na serwerze FTP WODGiK',
    value: 'Udostępnienie na serwerze FTP WODGiK',
    state: 'deliveryMethod',
  },
  {
    label: 'wysyłka na wskazany adres e-mail',
    value: 'Wysyłka na wskazany adres e-mail',
    state: 'deliveryMethod',
  },
];

const disabledContactDict = {
  firstName: {
    label: 'Imię',
    editable: false,
  },
  lastName: {
    label: 'Nazwisko',
    editable: false,
  },
  PhoneNumber: {
    label: 'Telefon',
    editable: false,
  },
  email: {
    label: 'Email',
    editable: false,
  },
};

const infoDict = {
  oznaczenie: {
    label: 'Oznaczenie wniosku nadane przez wnioskodawcę*',
    editable: true,
  },
};

const infoDict2 = {
  uwagi: {
    label: 'Dodatkowe wyjaśnienia i uwagi wnioskodawcy*',
    editable: true,
    type: 'textarea',
  },
};

const userDeviceText = 'udostępnianie na nośniku zewnętrznym wnioskodawcy';

const printedSharingMethod =  'drukowana';
const polygraphicMethod = 'druk poligraficzny';
const blackWhiteFormat = 'czarno-biały';
const colorFormat = 'kolorowy';

const rasterSharingMethod = 'rastrowa'


class UdostepnienieMaterialow extends React.Component {
  state = {
    contact: {
      firstName: null,
      lastName: null,
      PhoneNumber: null,
      email: null,
    },
    sharing: {
      sharingReason: null,
    },
    public: {
      zadaniePubliczne: null,
      podstawaPrawna: null,
      okresUdostepnienia: new Date().toISOString(),
    },
    delivery: {
      deliveryMethod: null,
      deliveryAddress: 'jak w nagłówku',
      deliveryAddressCity: '',
      deliveryAddressStreet: '',
      deliveryAddressNumber: '',
      deliveryAddressFlat: '',
      deliveryAddressZipCode: '',
      deliveryAddressMail: '',
      userDevice: false,
      deliveryEmail: '',
    },
    listMaterials: [{
      printigAvailabilty: {},
      printingDisabled: false,
      selectedMaterialName: '',
      category: '',
      materialGeoms: {},
      rasterFormats: {},
      selectedRasterFormats: [],
      selectedMaterialsList: [],
      selectionGroups: [],
      highlightedGeoms: [],
      areaSelection: 'jednostki podziału terytorialnego kraju',
      godlo: null,

      voivodeship: null,
      voivodeshipTERYT: null,

      district: null,
      districtTERYT: null,

      community: null,
      communityTERYT: null,
      fetchedCommunities: [],
      communityOptions: [],
      communityTERYTOptions: [],

      town: null,
      townTERYT: null,
      fetchedTowns: [],
      townOptions: [],
      townTERYTOptions: [],

      sharingMethod: '',
      printedSharingMethod: '',
      printedSharingMethodDetails: '',

      listPolygons: [
        {
          X: '',
          Y: '',
        },
        {
          X: '',
          Y: '',
        },
        {
          X: '',
          Y: '',
        },
      ],
      shapefile:
      {
        name: '',
        file: '',
      },
    }],
    otherCustomMaterialsOptions: [],
    otherKartoMaterialsOptions: [],
    otherMaterialsOptions: [],
    info: {
      oznaczenie: null,
      uwagi: null,
    },
    districEmail: '',
    districtOptions: [],
    sendServiceData: false,
    districtTERYTOptions: [],
    allDistricts: [],
    voivodeship: [],
    voivodeshipOptions: [],
    voivodeshipTERYTOptions: [],
    deliveryMethods: null,
    enabledMaterials: [],
    enabled_materials_dict: {},
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    showHelpModal: false,
    eserviceDistrict: null,
    selectedParcels: [],
    contactAsUser: true,
    style: {},
    loading: false,
    isPrintedSharingMethod: false,
    isWorking: false,
    jobId: null,
    pzgik_id: null,
    validated: false,
    attachments: null,
    jobStatus: null,
    modalBody:
    this.props.serviceInfo.eservice.requiresUserInfo
    ? <div>
        <center>
          <img role="presentation" src={waiting} style={{ width: '150px', height: '150px' }} />
        </center>
        <center>
          Trwa generowanie zasobu i obliczanie opłaty za wnioskowany materiał.
        </center>
        <center>
          W zależności od wielkości zamawianego materiału proces może trwać od kilku do kilkunastu minut.
        </center>
        <center>
          Nie zamykaj okna przeglądarki!
        </center>
      </div>
    : <div>
        <center>
          <img role="presentation" src={waiting} style={{ width: '150px', height: '150px' }} />
        </center>
        <center>
          Trwa generowanie wniosku.
        </center>
        <center>
          Nie zamykaj okna przeglądarki!
        </center>
      </div>,
    modalText: this.props.serviceInfo.eservice.requiresUserInfo ? 'Obliczanie opłaty' : 'Generowanie wniosku',
    personalData: {
      FirstName: '',
      LastName: '',
      FullName: '',
      AddressCity: '',
      AddressStreet: '',
      AddressNumber: '',
      AddressFlat: '',
      AddressZipCode: '',
      AddressMail: '',
      PhoneNumber: '',
      Email: '',
      Regon: '',
      Nip: '',
    },
    mainFactors: {},
    publicService: false,
    showUserModal: false,
    skipProfileChecking: false,
  };

  validators = {
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    this.fetchStyle();
    this.fetchEserviceDistrict();
    this.fetchDeliveryMethods();
    this.fetchEnabledMaterials();
    this.fetchVoivodeship();
    this.fetchDistrictOptions();
    this.fetchCommunities(0);
    this.fetchTowns(0);
    this.updateUser();
    this.updateService();
    this.fetchDistrictInfo();
  }

  updateValidators() {
    if (this.state.publicService) {
      this.validators = {
        zadaniePubliczne: [v.NotNull],
        podstawaPrawna: [v.NotNull],
        okresUdostepnienia: [v.NotNull],
        deliveryEmail: [v.NotNull, v.CheckEmail],
      };
    } else {
      this.validators = {
        firstName: [v.NotNull],
        lastName: [v.NotNull],
        PhoneNumber: [v.NotNull, v.isNumber],
        email: [v.NotNull, v.CheckEmail],
        deliveryEmail: [v.NotNull, v.CheckEmail],
        FirstName: [v.NotNull],
        LastName: [v.NotNull],
        AddressCity: [v.NotNull],
        AddressNumber: [v.NotNull],
        AddressZipCode: [v.NotNull],
        AddressMail: [v.NotNull],
        Email: [v.NotNull, v.CheckEmail],
        Regon: [v.CheckREGON],
        Nip: [v.CheckNIP],
      };
    }
  }

  fetchDistrictInfo() {
    const keys = Object.keys(this.props.districts);
    const prefix = keys[0];
    const districtEmail = this.props.districts[prefix].email;
    this.setState({ districtEmail });
  }

  updateService() {
    if (this.props.serviceInfo.eservice.shortName === 'UdostepnienieMaterialowPublicznych') {
      this.setState({ publicService: true }, () => this.updateValidators());
    } else {
      this.setState({ publicService: false }, () => this.fetchMainFactors());
    }
  }

  updateUser() {
    if (this.props.serviceInfo.user) {
      this.setState({
        personalData: this.props.serviceInfo.user,
      }, () => this.updateDeliveryAddress());
    }
  }

  updateDeliveryAddress() {
    let address = {
      AddressCity: '',
      AddressStreet: '',
      AddressNumber: '',
      AddressFlat: '',
      AddressZipCode: '',
      AddressMail: '',
    }
    if (this.state.delivery.deliveryAddress !== deliveryAddressOtherOption) {
      address = Object.assign(address, this.state.personalData);
    }
    this.setState({
      delivery: {
        ...this.state.delivery,
        deliveryAddressCity: address.AddressCity,
        deliveryAddressStreet: address.AddressStreet,
        deliveryAddressNumber: address.AddressNumber,
        deliveryAddressFlat: address.AddressFlat,
        deliveryAddressZipCode: address.AddressZipCode,
        deliveryAddressMail: address.AddressMail,
        deliveryEmail: this.state.personalData.Email,
      },
      contact: {
        firstName: this.state.personalData.FirstName,
        lastName: this.state.personalData.LastName,
        PhoneNumber: this.state.personalData.PhoneNumber,
        email: this.state.personalData.Email,
      }
    }, () => this.validateContact())
  }

  componentDidUpdate() {
    this.checkUserDevice();
  }

  fetchStyle() {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
      };
    }
    this.setState({ colors, sourceStyle, style });
  }

  fetchMainFactors() {
    if (!this.state.publicService) {
      fetch(`${process.env.API_URL}/getPZGiKMainFactors/${this.props.serviceInfo.eservice.shortName}/`)
        .then(r => r.json())
        .then(mainFactors => {
          this.setState({
            mainFactors,
          }, () => this.updateValidators());
        });
    }
  }

  fetchEserviceDistrict() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });
  }

  fetchDeliveryMethods() {
    fetch(`${process.env.API_URL}/deliveryMethods/${this.props.district}`, {
      method: 'GET',
    })
    .then(r => r.json())
    .then(resp => {
      this.setState({
        deliveryMethods: resp.delivery_methods,
      });
    });
  }

  fetchEnabledMaterials() {
    fetch(`${process.env.API_URL}/enabledMaterials/`, {
      method: 'GET',
    })
    .then(r => r.json())
    .then(resp => {
      this.setState({
        enabledMaterials: resp.enabled_materials_names,
        enabled_materials_dict: resp.enabled_materials_dict,
      }, () => this.setOtherMaterialsDict(resp));
    });
  }

  setOtherMaterialsDict = (resp) => {
    const otherCustomMaterialsOptions = [];
    for (const name of resp.other_custom_materials) {
      otherCustomMaterialsOptions.push({
        label: name,
        value: name,
        state: 'selectedMaterialName',
        category: 3,
      });
    }

    const otherKartoMaterialsOptions = [];
    for (const name of resp.other_karto_materials) {
      otherKartoMaterialsOptions.push({
        label: name,
        value: name,
        state: 'selectedMaterialName',
        category: 4,
      });
    }
    const otherMaterialsOptions = [];
    for (const name of resp.other_materials) {
      otherMaterialsOptions.push({
        label: name,
        value: name,
        state: 'selectedMaterialName',
        category: 5,
      });
    }

    this.setState({ otherCustomMaterialsOptions, otherKartoMaterialsOptions, otherMaterialsOptions });
  }


  fetchVoivodeship() {
    fetch(`${process.env.API_URL}/fetchVoivodeship/${this.props.district}/`, {
      method: 'GET',
    })
    .then(r => r.json())
    .then(voivodeship => {
      const voivodeshipOptions = [
        {
          label: voivodeship[0].voivodeship,
          value: voivodeship[0].voivodeship,
          state: 'voivodeship',
        },
      ];

      const voivodeshipTERYTOptions = [
        {
          label: voivodeship[0].teryt,
          value: voivodeship[0].teryt,
          state: 'voivodeshipTERYT',
        },
      ];
      this.setState({
        voivodeship,
        voivodeshipOptions,
        voivodeshipTERYTOptions
      });
    });
  }

  fetchDistrictOptions() {
    fetch(`${process.env.API_URL}/districtOptions/${this.props.district}/`, {
      method: 'GET',
    })
    .then(r => r.json())
    .then(resp => {
      const districtOptions = [];
      const districtTERYTOptions = [];
      const allDistricts = [];

      for (const dist of resp) {
        districtOptions.push({
          label: dist.district,
          value: dist.district,
          state: 'district',
        });
        districtTERYTOptions.push({
          label: dist.teryt,
          value: dist.teryt,
          state: 'districtTERYT',
        });
        allDistricts.push({
          district: dist.district,
          teryt: dist.teryt,
          geometry: dist.geometry,
        });
      }

      this.setState({
        districtOptions, districtTERYTOptions, allDistricts,
      });
    });
  }

  fetchCommunities(idx) {
    const listMaterials = _.cloneDeep(this.state.listMaterials);
    fetch(`${process.env.API_URL}/getCommunities/${encodeURIComponent(listMaterials[idx].districtTERYT)}/`, {
      method: 'GET',
    })
    .then(r => r.json())
    .then(allCommunities => {
      listMaterials[idx].fetchedCommunities = allCommunities;
      this.setState({
        listMaterials,
      }, () => this.getCommunityOptions(idx));
    });
  }

  fetchTowns(idx) {
    const listMaterials = _.cloneDeep(this.state.listMaterials);
    fetch(`${process.env.API_URL}/getTowns/${encodeURIComponent(this.state.listMaterials[idx].communityTERYT)}/`, {
      method: 'GET',
    })
    .then(r => r.json())
    .then(allTowns => {
      listMaterials[idx].fetchedTowns = allTowns;
      this.setState({
        listMaterials,
      }, () => this.getTownOptions(idx));
    });
  }

  fetchMaterialsGeoms(materialName, index) {
    fetch(`${process.env.API_URL}/getMaterialGeoms/?material_name=${encodeURIComponent(materialName)}`, {
      method: 'GET',
    })
    .then(r => r.json())
    .then(resp => {
      const arr = _.cloneDeep(this.state.listMaterials);
      arr[index].materialGeoms = resp.geoms;
      arr[index].rasterFormats = resp.raster_formats;
      this.setState({
        listMaterials: arr,
      }, () => this.checkPrintingAvailability(materialName, index));
    });
  }

  checkPrintingAvailability(materialName, index) {
    fetch(`${process.env.API_URL}/checkPrintingAvailability/?material_name=${encodeURIComponent(materialName)}`, {
      method: 'GET',
    })
    .then(r => r.json())
    .then(resp => {
      const arr = _.cloneDeep(this.state.listMaterials);
      arr[index].printingDisabled = resp.printing_disabled;
      this.setState({
        listMaterials: arr,
      }, () => this.fetchMaterialPrintingAvailability(materialName, index));
    });
  }

  fetchMaterialPrintingAvailability(materialName, index) {
    const listMaterials = _.cloneDeep(this.state.listMaterials);
    if (!listMaterials[index].printingDisabled) {
      fetch(`${process.env.API_URL}/materialAvailability/?material_name=${encodeURIComponent(materialName)}`, {
        method: 'GET',
      })
      .then(r => r.json())
      .then(resp => {
        listMaterials[index].printigAvailabilty = resp.materials;
        this.setState({
          listMaterials,
        }, () => this.resetSharingMethod(index));
      });
    } else { this.resetSharingMethod(index); }
  }

  checkFinalPrintingAvailability = () => {
    const materialsList = this.createPrintedMaterialsList();

    if (materialsList.length > 0) {
      return fetch(`${process.env.API_URL}/finalAvailability/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ materialList: materialsList }),
      })
      .then(r => r.json())
      .then(resp => {
        if (resp.status === 200) {
          const materials = resp.materials;
          return materials;
        }
        this.onJobFailed();
        return;
      });
    }

    return [];
  }

  createPrintedMaterialsList = () => {
    const materialList = [];

    for (const material of this.state.listMaterials) {
      for (const singleMat of material.selectedMaterialsList) {
        if (material.sharingMethod === printedSharingMethod) {
          if ([colorFormat, blackWhiteFormat].includes(material.printedSharingMethod)) {
            materialList.push(
              {
                idMaterialu: singleMat.properties.idMaterialu,
                type: material.printedSharingMethod,
              },
            );
          } else {
            materialList.push(
              {
                idMaterialu: singleMat.properties.idMaterialu,
                type: material.printedSharingMethodDetails,
                count: parseInt(singleMat.properties.count),
              },
            );
          }
        }
      }
    }
    return materialList;
  }

  resetSharingMethod = (idx) => {
    const listMaterials = _.cloneDeep(this.state.listMaterials);

    listMaterials[idx].sharingMethod = null;

    this.setState({
      listMaterials,
      loading: false,
    });
  }

  fetchMaterialsIntersection = (unitType, unitTeryt, materialName) => {
    return fetch(`${process.env.API_URL}/checkMaterialIntersection/?unit_type=${encodeURIComponent(unitType)}&unit_teryt=${encodeURIComponent(unitTeryt)}&material_name=${encodeURIComponent(materialName)}`, {
      method: 'GET',
    })
    .then(r => r.json())
    .then(resp => {
      return resp;
    });
  }

  addMaterial = () => {
    this.setState({
      listMaterials: [...this.state.listMaterials, {
        printigAvailabilty: {},
        printingDisabled: false,
        selectedMaterialName: '',
        category: '',
        materialGeoms: {},
        rasterFormats: {},
        selectedRasterFormats: [],
        selectedMaterialsList: [],
        selectionGroups: [],
        highlightedGeoms: [],
        areaSelection: 'jednostki podziału terytorialnego kraju',
        godlo: null,

        voivodeship: null,
        voivodeshipTERYT: null,

        district: null,
        districtTERYT: null,

        community: null,
        communityTERYT: null,
        fetchedCommunities: [],
        communityOptions: [],
        communityTERYTOptions: [],

        town: null,
        townTERYT: null,
        fetchedTowns: [],
        townOptions: [],
        townTERYTOptions: [],

        sharingMethod: '',
        printedSharingMethod: '',
        printedSharingMethodDetails: '',

        listPolygons: [
          {
            X: '',
            Y: '',
          },
          {
            X: '',
            Y: '',
          },
          {
            X: '',
            Y: '',
          },
        ],
        shapefile:
        {
          name: '',
          file: '',
        },
      }],
    });
  }

  removeMaterial = (i, state) => {
    const list = [...this.state[state]]

    if (i > -1) {
      list.splice(i, 1);
    }

    this.setState({
      [state]: list,
    });
  }

  removeSelectionGroup = (idx, selectionGroup) => {
    const list = [...this.state.listMaterials[idx].selectedMaterialsList];
    const matList = [];
    for (const mat of list) {
      if (mat.properties.selectionGroup === selectionGroup) {
        matList.push(mat.properties.name);
      }
    }

    for (const name of matList) {
      this.removeSelectedMaterial(idx, name);
    }
  }

  removeHighlight = (idx) => {
    this.setState(({ listMaterials }) => {
      listMaterials[idx].highlightedGeoms = [];
      return { listMaterials }
    })
  }


  removeSelectedMaterials = (idx) => {
    this.setState(({ listMaterials }) => {
      listMaterials[idx].selectedMaterialsList = [];
      listMaterials[idx].highlightedGeoms = [];
      return { listMaterials }
    })
  }

  removeSelectedMaterial = (idx, name) => {
    const list = [...this.state.listMaterials[idx].selectedMaterialsList];

    let subidx = null;
    for (const mat of list) {
      if (mat.properties.name === name) {
        subidx = list.indexOf(mat);
        break;
      }
    }
    if (subidx !== null && subidx > -1) {
      list.splice(subidx, 1);
    }

    const arr = _.cloneDeep(this.state.listMaterials);
    arr[idx].selectedMaterialsList = list;
    arr[idx].highlightedGeoms = [];

    const allSelectiongroups = [];
    for (const mat of list) {
      if (!allSelectiongroups.includes(mat.properties.selectionGroup)) {
        allSelectiongroups.push(mat.properties.selectionGroup);
      }
    }

    let selectionIdx = null;
    for (const selectionType of arr[idx].selectionGroups) {
      if (!allSelectiongroups.includes(selectionType)) {
        selectionIdx = arr[idx].selectionGroups.indexOf(selectionType);
        arr[idx].selectionGroups.splice(selectionIdx, 1);
      }
    }

    this.setState({
      listMaterials: arr,
    });
  }

  removePolygonVertex = (idx, subidx) => {
    const list = [...this.state.listMaterials[idx].listPolygons];

    if (subidx > -1) {
      list.splice(subidx, 1);
    }

    this.setState(({ listMaterials }) => {
      listMaterials[idx].listPolygons = list;
      return { listMaterials }
    })
  }

  validateAttachmentsContent = () => {
    for (const attachment of this.state.attachments) {
      if (attachment.name.length < 1) return true;
    }
    return false;
  }

  changeSelectionToGodlo = (idx) => {
    this.setState(({ listMaterials }) => {
      listMaterials[idx].areaSelection = 'godło arkusza mapy';
      return { listMaterials }
    })
  }

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  onChangeMaterial = (e, state, elem, index) => {
    const arr = _.cloneDeep(this.state[state]);
    if (['userDevice'].includes(elem)) {
      arr[index][elem] = e.target.checked;
    } else {
      arr[index][elem] = e.target.value;
    }

    if (arr[index].selectedMaterialsList.length) {
      if (arr[index].sharingMethod === printedSharingMethod
        && !(
          arr[index].printedSharingMethod === polygraphicMethod
          && !arr[index].printedSharingMethodDetails
        )
      ) {
        arr[index].selectedMaterialsList.forEach(material =>
          this.preventFromTakingTooMany(index, material)
        );
      } else {
        arr[index].selectedMaterialsList.forEach(material =>
          material.properties.count = 1
        );
      }
    }

    if (elem === 'sharingMethod') {
      let isPrintedSharingMethod = false;
      if (!printedSharingMethods.includes(e.target.value)) {
        arr[index].printedSharingMethod = null;
        arr[index].printedSharingMethodDetails = null;
      }
      for (const material of arr) {
        if (printedSharingMethods.includes(material.sharingMethod)) {
          isPrintedSharingMethod = true;
          break;
        }
      }
      this.setState({
        [state]: arr,
        isPrintedSharingMethod,
      }, () => this.validateMaterials(state, elem, index),
      );
    } else {
      this.setState({
        [state]: arr,
      }, () => this.validateMaterials(state, elem, index),
      );
    }
  }

  onChangeCheckbox = (e, group, state) => {
    const arr = _.cloneDeep(this.state[group]);

    arr[state] = e.target.checked;
    this.setState({
      [group]: arr,
    });
  }

  onChangeSelectedMaterial = (e, group, index, subgroup, subindex, elem) => {
    const arr = _.cloneDeep(this.state[group]);
    arr[index][subgroup][subindex].properties[elem] = e.target.value;

    this.setState({
      [group]: arr,
    });
  }

  onChangePolyVertex = (e, group, index, subgroup, subindex, elem) => {
    const arr = _.cloneDeep(this.state[group]);
    arr[index][subgroup][subindex][elem] = e.target.value;

    this.setState({
      [group]: arr,
    });
  }

  onChangeMapMaterial = (e, state, elem, index, cat) => {
    const arr = _.cloneDeep(this.state[state]);
    const value = e.target.value;
    arr[index][elem] = value;
    arr[index].category = categoriesDict[cat];
    arr[index].selectedMaterialsList = [];
    arr[index].selectedRasterFormats = [];

    this.setState({
      [state]: arr,
      loading: true,
    }, () => this.fetchMaterialsGeoms(value, index),
    );
  }

  renderRasterFormats = (index) => {

    const rasterFormats = this.state.listMaterials[index].rasterFormats;
    const selectedRasterFormats = this.state.listMaterials[index].selectedRasterFormats;
    return (
      <div>
        {rasterFormats.geotiff.length > 0 ?
          <p>
            <b>w formacie GeoTIFF (skalibrowany, docięty do treści mapy)</b>
          </p>
        : null}
        {rasterFormats.geotiff.map((item, idx) => (
          <div className={s.subtitle} key={`rasterFormatsCheckbox_div_${index}_${idx}`}>
            <input
              id={`rasterFormatsCheckbox_${index}_${idx}`}
              name="isDefault"
              type="checkbox"
              value={selectedRasterFormats.includes(item)}
              onChange={() => this.changeRasterFormats(item, index)}
            />
            <label htmlFor={`rasterFormatsCheckbox_${index}_${idx}`}>&nbsp;&nbsp;{item}</label>
          </div>
        ))}
        <br />
        {rasterFormats.other.length > 0 ?
          <p>
            <b>w innym formacie (nieskalibrowany z ramką)</b>
          </p>
        : null}
        {rasterFormats.other.map((item, idx) => (
          <div className={s.subtitle} key={`rasterFormatsOtherCheckbox_div_${index}_${idx}`}>
            <input
              id={`rasterFormatsOtherCheckbox_${index}_${idx}`}
              name="isDefault"
              type="checkbox"
              value={selectedRasterFormats.includes(item)}
              onChange={() => this.changeRasterFormats(item, index)}
            />
            <label htmlFor={`rasterFormatsOtherCheckbox_${index}_${idx}`}>&nbsp;&nbsp;{item}</label>
          </div>
        ))}
        {(rasterFormats.geotiff.length < 1 && rasterFormats.other.length < 1) ?
          <p>
            <b>brak dostępnych formatów rastrowych</b>
          </p>
        : null}
      </div>);
  }

  renderMaterialRadioButtons = (buttonsList, group, state, index) => {
    for (const button of buttonsList) {
      button.disabled = this.checkIfRadioDisbled(index, button, state);
    }
    return (
      <div>
        {buttonsList.map((item, idx) => (
          <div key={`materialRadio${item}_${index}_${idx}`} className="radio">
            <label
              // htmlFor={`materialRadio${item}_${index}_${idx}`}
              style={item.disabled ? { color: 'gray' } : null}
            >
              <input
                type="radio"
                value={item.value}
                disabled={item.disabled}
                name={`${state}#${index}`}
                checked={this.state[group][index][state] === item.value}
                onChange={e => this.onChangeMaterial(e, group, state, index)}
              />
              <b>{`    ${item.label}`}<br /></b>
            </label>
          </div>
        ))}
      </div>);
  }

  checkIfRadioDisbled = (index, item, state) => {
    let disabled = false;

    const enabled_materials_dict = this.state.enabled_materials_dict;
    const selectedMaterialName = this.state.listMaterials[index].selectedMaterialName;

    if (state === 'sharingMethod') {
      if (freeSharingReasonValues.includes(this.state.sharing.sharingReason) && !freeSharingMethodValues.includes(item.value)) {
        disabled = true;
      }
      if (selectedMaterialName && freeSharingMethodValues.includes(item.value) && !enabled_materials_dict[selectedMaterialName][item.value]) {
        disabled = true;
      }
      if (disabled && this.state.listMaterials[index].sharingMethod === item.value) {
        const listMaterials = _.cloneDeep(this.state.listMaterials);
        listMaterials[index].sharingMethod = null;
        this.setState({ listMaterials });
      }
      if (item.value === printedSharingMethod && selectedMaterialName) {
        disabled = this.state.listMaterials[index].printingDisabled;
        if (freeSharingReasonValues.includes(this.state.sharing.sharingReason)) {
          disabled = true;
        }
      }
    }

    if (!this.state.listMaterials[index].selectedMaterialName) {
      disabled = true;
    }

    return disabled;
  }

  checkUserDevice = () => {
    for (const material of this.state.listMaterials) {
      if (material.sharingMethod === printedSharingMethod) {
        if (this.state.delivery.userDevice) {
          this.setState({ delivery: {
            ...this.state.delivery,
            userDevice: false,
          },
          });
        }
        break;
      }
    }
  }

  checkIfCheckBoxDisbled = () => {
    let disabled = false;

    for (const material of this.state.listMaterials) {
      if (material.sharingMethod === printedSharingMethod) {
        disabled = true;
        break;
      }
    }

    return disabled;
  }

  renderMapRadioButtons = (buttonsList, group, state, index) => {
    const enabledButtons = [];
    for (const button of buttonsList) {
      if (this.state.enabledMaterials.includes(button.value)) {
        enabledButtons.push(button);
      }
    }
    return (
      <div>
        {enabledButtons.length > 0 ? enabledButtons.map((item, idx) => (
          <div key={`mapRadio${item}_${index}_${idx}`} className="radio">
            <label
              style={!this.state.enabledMaterials.includes(item.value) ? { color: 'gray' } : null}
            >
              <input
                disabled={!this.state.enabledMaterials.includes(item.value)}
                type="radio"
                value={item.value}
                name={`${state}#${index}`}
                checked={this.state[group][index][state] === item.value}
                onChange={e => this.onChangeMapMaterial(e, group, state, index, item.category)}
              />
              <b>{`    ${item.label}`}<br /></b>
            </label>
          </div>
        )) : <p>brak aktywnych opracowań</p>}
      </div>);
  };

  validateMaterials = (group = null, field = null, index = null) => {
    let newState = null;
    if (field) {
      const checks = this.validateMaterialField(group, field, index);
      newState = {
        errors: {
          ...this.state.errors,
          [`${field}${index}`]: checks,
        },
      };
    } else {
      let errors = {};
      const grupy = ['listMaterials'];
      for (const g of grupy) {
        const err = this.validateListGroups(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...this.state.errors, ...errors } };
    }

    if (newState) {
      this.setState(newState);
    }
  };

  getInputWithError = (group, field, idx, value, placeholder) => (
    <div style={{ textAlign: 'justify' }}>
      <input
        type="text"
        className="form-control"
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(`${field}${idx}`) > -1 &&
              this.state.errors[`${field}${idx}`] !== null &&
              this.state.errors[`${field}${idx}`].length > 0
              ? 'red'
              : '#ccc',
        }}
        value={value}
        placeholder={placeholder}
        onChange={(e) => this.onChangeMaterial(e, group, field, idx)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(`${field}${idx}`) > -1 &&
        this.state.errors[`${field}${idx}`] !== null &&
        this.state.errors[`${field}${idx}`].length > 0
        ? this.state.errors[`${field}${idx}`].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </div>
  )

  getGodloSelect = (group, field, idx) => {
    const options = this.getGodloOptions(idx);
    return (
      <GrayPanel title="Godło arkusza mapy" >
        <div className="col-lg-12">
          <Col key={`getGodloSelect${idx}col1`} xs={2} sm={2} md={2} >
            <p><b>Godło arkusza mapy</b></p>
          </Col>
          <Col key={`getGodloSelect${idx}col2`} xs={8} sm={8} md={8}>
            <Select
              noResultsText={'brak wyników'}
              clearable={false}
              options={options}
              value={this.state[group][idx][field]}
              placeholder={'Wybierz z listy...'}
              onChange={e => this.onChangeGodloSelect(e, group, field, idx)}
              style={{
                width: '100%',
                borderColor:
                  Object.keys(this.state.errors).indexOf(`${field}${idx}`) > -1 &&
                    this.state.errors[`${field}${idx}`] !== null &&
                    this.state.errors[`${field}${idx}`].length > 0
                    ? 'red'
                    : '#ccc',
              }}
            />
            {/* RENDER ERROS IN SPAN */}
            {Object.keys(this.state.errors).indexOf(`${field}${idx}`) > -1 &&
              this.state.errors[`${field}${idx}`] !== null &&
              this.state.errors[`${field}${idx}`].length > 0
              ? this.state.errors[`${field}${idx}`].map((val, index) => (
                <span key={index} style={errorSpanStyle}>
                  {val}
                </span>
              ))
              : null}
          </Col>
          <Col key={`getGodloSelect${idx}col3`} xs={2} sm={2} md={2}>
            <button
              type="submit-lg"
              className={'btn btn-success'}
              disabled={this.state.listMaterials[idx].godlo === null}
              style={{ btnStyle }}
              onClick={() => this.addGeomByGodlo(idx)}
            >
              Dodaj
            </button>
          </Col>
        </div>
      </GrayPanel>
    );
  }

  getPolyInput(group, state, index) {
    return (
      <input
        value={this.state[group][index][state]}
        name={`${state}#${index}`}
        onChange={e => this.onChangeMaterial(e, group, state, index)}
      />
    );
  }

  getDistrictSelect(group, field, idx, options) {
    return (
      <Select
        noResultsText={'brak wyników'}
        clearable={false}
        options={options}
        value={this.state[group][idx][field]}
        placeholder={'Wybierz z listy...'}
        onChange={e => this.onChangeDistrictSelect(e, group, field, idx)}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(`${field}${idx}`) > -1 &&
              this.state.errors[`${field}${idx}`] !== null &&
              this.state.errors[`${field}${idx}`].length > 0
              ? 'red'
              : '#ccc',
        }}
      />
    );
  }

  getDistrictSelection = (group, idx) => {
    return (
      <GrayPanel title="Jednostka podziału terytorialnego" >
        <div className="col-lg-12">
          <Col key={`getDistrictSelectionTitle${idx}col1`} xs={2} sm={2} md={2} />
          <Col key={`getDistrictSelectionTitle${idx}col2`} xs={4} sm={4} md={4} style={{ textAlign: 'center' }}>
            <p><b>NAZWA</b></p>
          </Col>
          <Col key={`getDistrictSelectionTitle${idx}col3`} xs={4} sm={4} md={4} style={{ textAlign: 'center' }}>
            <p><b>TERYT</b></p>
          </Col>
          <Col key={`getDistrictSelectionTitle${idx}col4`} xs={2} sm={2} md={2} />
        </div>
        <div className="col-lg-12">
          <Col key={`voivodeship${idx}col1`} xs={2} sm={2} md={2}>
            <p><b>Województwo</b></p>
          </Col>
          <Col key={`voivodeship${idx}col2`} xs={4} sm={4} md={4}>
            {this.getDistrictSelect(group, 'voivodeship', idx, this.state.voivodeshipOptions)}
          </Col>
          <Col key={`voivodeship${idx}col3`} xs={4} sm={4} md={4}>
            {this.getDistrictSelect(group, 'voivodeshipTERYT', idx, this.state.voivodeshipTERYTOptions)}
          </Col>
          <Col key={`voivodeship${idx}col4`} xs={2} sm={2} md={2} >
            {this.getSelectionButton(group, 'voivodeship', idx, 500)}
          </Col>
        </div>
        <div className="col-lg-12">
          <Col key={`district${idx}col1`} xs={2} sm={2} md={2} >
            <p><b>Powiat</b></p>
          </Col>
          <Col key={`district${idx}col2`} xs={4} sm={4} md={4}>
            {this.getDistrictSelect(group, 'district', idx, this.state.districtOptions)}
          </Col>
          <Col key={`district${idx}col3`} xs={4} sm={4} md={4}>
            {this.getDistrictSelect(group, 'districtTERYT', idx, this.state.districtTERYTOptions)}
          </Col>
          <Col key={`district${idx}col4`} xs={2} sm={2} md={2} >
            {this.getSelectionButton(group, 'district', idx, 300)}
          </Col>
        </div>
        <div className="col-lg-12">
          <Col key={`community${idx}col1`} xs={2} sm={2} md={2} >
            <p><b>Gmina</b></p>
          </Col>
          <Col key={`community${idx}col2`} xs={4} sm={4} md={4}>
            {this.getDistrictSelect(group, 'community', idx, this.state.listMaterials[idx].communityOptions)}
          </Col>
          <Col key={`community${idx}col3`} xs={4} sm={4} md={4}>
            {this.getDistrictSelect(group, 'communityTERYT', idx, this.state.listMaterials[idx].communityTERYTOptions)}
          </Col>
          <Col key={`community${idx}col4`} xs={2} sm={2} md={2} >
            {this.getSelectionButton(group, 'community', idx, 300)}
          </Col>
        </div>
        <div className="col-lg-12">
          <Col key={`town${idx}col1`} xs={2} sm={2} md={2} >
            <p><b>Obręb</b></p>
          </Col>
          <Col key={`town${idx}col2`} xs={4} sm={4} md={4}>
            {this.getDistrictSelect(group, 'town', idx, this.state.listMaterials[idx].townOptions)}
          </Col>
          <Col key={`town${idx}col3`} xs={4} sm={4} md={4}>
            {this.getDistrictSelect(group, 'townTERYT', idx, this.state.listMaterials[idx].townTERYTOptions)}
          </Col>
          <Col key={`town${idx}col4`} xs={2} sm={2} md={2} >
            {this.getSelectionButton(group, 'town', idx, 300)}
          </Col>
        </div>
      </GrayPanel>
    );
  }

  getFileSelection = (idx) => {
    return (
      <GrayPanel title="Obszar określony w załączniku" >
        <p><b>Wymagany układ współrzędnych pliku .shp: WGS-84 (EPSG: 4326)</b></p>
        <div className="col-lg-12">
          <Col key={`shapefile${idx}col1`} xs={2} sm={2} md={2} >
            <p style={labelStyle}><b>Dodaj plik</b></p>
          </Col>
          <Col key={`shapefile${idx}col2`} xs={6} sm={6} md={6} style={{ paddingLeft: '30px', paddingRight: '0px' }}>
            <input disabled value={this.state.listMaterials[idx].shapefile.name} style={{ width: '100%', marginTop: '0.5rem' }} />
          </Col>
          <Col key={`shapefile${idx}col3`} xs={1} sm={1} md={1} style={{ paddingLeft: '1px', paddingRight: '30px' }}>
            <label htmlFor={`shapefile${idx}`} style={{ marginTop: '0.5rem', border: '1px solid grey', paddingLeft: '5px', paddingRight: '15px', paddingBottom: '3px' }} >...</label>
          </Col>
          <Col key={`shapefile${idx}col4`} xs={1} sm={1} md={1} style={{ padding: '0px' }} >
            <input style={{ visibility: 'hidden' }} id={`shapefile${idx}`} type="file" accept=".shp" onChange={(e) => this.onShapefileChange(e, idx)} />
          </Col>
          <Col key={`shapefile${idx}col5`} xs={2} sm={2} md={2} >
            {this.getShapefileSelectionButton('shapefile', idx)}
          </Col>
        </div>
      </GrayPanel>
    );
  }

  onShapefileChange = async (e, idx) => {
    const file = e.target.files[0];
    const name = file.name;
    const extension = name.split('.').slice(-1)[0];
    let shapefile = {};
    if (['shp'].includes(extension)) {
      shapefile = { name, file };
      const listMaterials = _.cloneDeep(this.state.listMaterials);
      listMaterials[idx].shapefile = shapefile;
      this.setState({ listMaterials });
    } else {
      this.setState({
        errorText: 'Wymagany format pliku to .shp.',
        errorTitle: 'Błędny format pliku.',
        showError: true,
      });
    }
  }

  getPolygonInput = (group, state, idx, val, subidx) => {
    return (
      <div style={{ textAlign: 'right' }}>
        <input
          className="form-control"
          name={`${group}#${idx}_${state}#${subidx}`}
          value={val[state]}
          style={inputStyle}
          onChange={(e) => this.onChangePolyVertex(e, group, idx, 'listPolygons', subidx, state)}
        />
      </div>
    );
  }

  getPolygonSelection = (group, idx) => {
    return (
      <GrayPanel title="Wspołrzędne wielokąta (poligonu)" >
        {this.state[group][idx].listPolygons.map((value, index) => {
          return (
            <div className="col-lg-12" key={`listPolygons${idx}_${index}`}>
              <Col key={`listPolygons${idx}_${index}col3`} xs={1} sm={1} md={1} style={{ paddingLeft: '30px', paddingRight: '0px' }}>
                <p style={labelStyle}>X</p>
              </Col>
              <Col key={`listPolygons${idx}_${index}col4`} xs={4} sm={4} md={4} style={{ paddingLeft: '0px', paddingRight: '8px' }}>
                {this.getPolygonInput(group, 'X', idx, value, index)}
              </Col>
              <Col key={`listPolygons${idx}_${index}col5`} xs={1} sm={1} md={1} style={{ paddingLeft: '30px', paddingRight: '0px' }}>
                <p style={labelStyle}>Y</p>
              </Col>
              <Col key={`listPolygons${idx}_${index}col6`} xs={4} sm={4} md={4} style={{ paddingLeft: '0px', paddingRight: '8px' }}>
                {this.getPolygonInput(group, 'Y', idx, value, index)}
              </Col>
              <Col key={`listPolygons${idx}_${index}col1`} xs={1} sm={1} md={1} >
                <button
                  type="submit-lg"
                  className={'btn btn-danger'}
                  style={{ btnStyle }}
                  onClick={() => this.removePolygonVertex(idx, index)}
                >
                  x
                </button>
              </Col>
            </div>);
        })}
        <br />
        <div className="col-lg-12">
          <Col key={`listPolygonsButtons${idx}col1`} xs={1} sm={1} md={1}>
            {this.getPolyVertexAddingButton(idx)}
          </Col>
          <Col key={`listPolygonsButtons${idx}col2`} xs={9} sm={9} md={9} />
          <Col key={`listPolygonsButtons${idx}col3`} xs={2} sm={2} md={2}>
            {this.getPolySelectionButton(idx)}
          </Col>
        </div>
      </GrayPanel>
    );
  }

  beginIntersection = (group, state, idx, timeout) => {
    this.setState({ loading: true }, () => this.addGeomByIntersection(group, state, idx, timeout));
  }


  addGeomByIntersection = (group, state, idx, timeout) => {
    setTimeout(async () => {
      const selectionDict = {
        voivodeship: this.state.voivodeship,
        district: this.state.allDistricts,
        community: this.state[group][idx].fetchedCommunities,
        town: this.state[group][idx].fetchedTowns,
      };

      let teryt = null;
      const name = this.state[group][idx][state];
      for (const obj of selectionDict[state]) {
        if (obj[state] === name) {
          teryt = obj.teryt;
        }
      }

      const materialName = this.state.listMaterials[idx].selectedMaterialName;

      const intersectedMaterials = await this.fetchMaterialsIntersection(state, teryt, materialName);

      let arr = _.cloneDeep(this.state.listMaterials);
      if (Object.keys(this.state.listMaterials[idx].materialGeoms).length !== 0) {
        for (const feature of this.state.listMaterials[idx].materialGeoms.features) {
          if (intersectedMaterials.godla.includes(feature.properties.godlo)) {
            const godlo = feature.properties.godlo;
            const skala = feature.properties.skala;
            const uklad = feature.properties.uklad;
            const idMaterialu = feature.properties.idMaterialu;
            const selectionGroup = `Jednostka podziału terytorialnego kraju lub podział dla celów EGiB - ${name}`;
            if (!arr[idx].selectionGroups.includes(selectionGroup)) {
              arr[idx].selectionGroups.push(selectionGroup);
            }
            if (this.geomExists(idx, godlo)) {
              arr = this.increaseMaterialCount(idx, godlo, arr);
            } else {
              let availableCount = this.getMaterialAvailability(idx, idMaterialu);
              arr[idx].selectedMaterialsList.push({
                type: 'Feature',
                properties: {
                  name: godlo,
                  count: (availableCount > 0) ? 1 : 0,
                  idMaterialu,
                  skala,
                  uklad,
                  selectionGroup,
                  teryt,
                },
                geometry: feature.geometry,
              });
            }
          }
        }
      }

      this.setState({
        listMaterials: arr,
        loading: false,
      });
    }, timeout);
  }

  beginShapefileIntersection = (idx) => {
    this.setState({ loading: true }, () => this.addGeomByShapefileIntersection(idx));
  }

  addGeomByShapefileIntersection = (idx) => {

    setTimeout(() => {
      const shape = this.state.listMaterials[idx].shapefile.file;
      let arr = _.cloneDeep(this.state.listMaterials);

      shape.arrayBuffer().then(buf => {
        readShapefile(buf)
          .then(results => {
            for (const feat of results.features) {
              const poly1 = buffer(multiPolygon([[feat.geometry.coordinates[0]]]), 0);
              if (Object.keys(this.state.listMaterials[idx].materialGeoms).length !== 0) {
                for (const feature of this.state.listMaterials[idx].materialGeoms.features) {
                  const poly2 = buffer(multiPolygon(feature.geometry.coordinates), 0);
                  const intersection = intersect(poly2, poly1);
                  if (intersection) {
                    const godlo = feature.properties.godlo;
                    const skala = feature.properties.skala;
                    const uklad = feature.properties.uklad;
                    const idMaterialu = feature.properties.idMaterialu;
                    const selectionGroup = 'Obszar określony w załączniku';
                    if (!arr[idx].selectionGroups.includes(selectionGroup)) {
                      arr[idx].selectionGroups.push(selectionGroup);
                    }
                    if (this.geomExists(idx, godlo)) {
                      arr = this.increaseMaterialCount(idx, godlo, arr);
                    } else {
                      let availableCount = this.getMaterialAvailability(idx, idMaterialu);
                      arr[idx].selectedMaterialsList.push({
                        type: 'Feature',
                        properties: {
                          name: godlo,
                          count: (availableCount > 0) ? 1 : 0,
                          idMaterialu,
                          skala,
                          uklad,
                          selectionGroup,
                        },
                        geometry: feature.geometry,
                      });
                    }
                  }
                }
              }
            }
          })
          .catch(error => this.setState({
            errorText: 'Wystąpił błąd przy otwieraniu pliku .shp. Upewnij się, że plik jest poprawny.',
            errorTitle: 'Błąd otwierania.',
            showError: true,
          }));
      });

      this.setState({
        listMaterials: arr,
        loading: false,
      });
    }, 500);
  }

  addGeomByRectangleIntersection = (idx, startPoint, endPoint) => {
    const coords = [[]];
    coords[0].push([startPoint.lng, startPoint.lat]);
    coords[0].push([startPoint.lng, endPoint.lat]);
    coords[0].push([endPoint.lng, endPoint.lat]);
    coords[0].push([endPoint.lng, startPoint.lat]);

    coords[0].push(coords[0][0]); // trzeba zamknąć poligon - pierwszy vertex = ostatni
    const poly1 = buffer(polygon(coords), 0);
    const selectionGroup = 'Godło arkusza mapy';

    this.checkPolygonIntersection(idx, poly1, selectionGroup);
  }

  addGeomByDrawedPolyIntersection = (idx, coords, pointCount) => {
    if (pointCount > 2) {
      coords[0].push(coords[0][0]); // trzeba zamknąć poligon - pierwszy vertex = ostatni
      const poly1 = buffer(polygon(coords), 0);
      const selectionGroup = 'Godło arkusza mapy';

      this.checkPolygonIntersection(idx, poly1, selectionGroup);
    } else {
      this.setState({
        errorText: 'Wielokąt musi składać się z co najmniej trzech punktów.',
        errorTitle: 'Błędne dane.',
        showError: true,
      });
    }
  }

  checkPolygonIntersection = (idx, poly1, selectionGroup) => {
    let arr = _.cloneDeep(this.state.listMaterials);
    if (Object.keys(this.state.listMaterials[idx].materialGeoms).length !== 0) {
      for (const feature of this.state.listMaterials[idx].materialGeoms.features) {
        const poly2 = buffer(multiPolygon(feature.geometry.coordinates), 0);
        const intersection = intersect(poly2, poly1);
        if (intersection) {
          const godlo = feature.properties.godlo;
          const skala = feature.properties.skala;
          const uklad = feature.properties.uklad;
          const idMaterialu = feature.properties.idMaterialu;
          if (!arr[idx].selectionGroups.includes(selectionGroup)) {
            arr[idx].selectionGroups.push(selectionGroup);
          }
          if (this.geomExists(idx, godlo)) {
            arr = this.increaseMaterialCount(idx, godlo, arr);
          } else {
            let availableCount = this.getMaterialAvailability(idx, idMaterialu);
            arr[idx].selectedMaterialsList.push({
              type: 'Feature',
              properties: {
                name: godlo,
                count: (availableCount > 0) ? 1 : 0,
                idMaterialu,
                skala,
                uklad,
                selectionGroup,
              },
              geometry: feature.geometry,
            });
          }
        }
      }
    }

    this.setState({
      listMaterials: arr,
    });
  }

  addGeomByPolyIntersection = (idx) => {
    if (this.state.listMaterials[idx].listPolygons.length > 2){
      const coords = [[]];
      for (const vertex of this.state.listMaterials[idx].listPolygons) {
        coords[0].push([vertex.X, vertex.Y]);
      }

      coords[0].push(coords[0][0]); // trzeba zamknąć poligon - pierwszy vertex = ostatni
      const coordsString = coords.toString();
      const poly1 = buffer(polygon(coords), 0);
      const selectionGroup = `Współrzędne wielokąta (${coordsString})`;

      this.checkPolygonIntersection(idx, poly1, selectionGroup);
    } else {
      this.setState({
        errorText: 'Wielokąt musi zawierać co najmniej trzy pary współrzędnych.',
        errorTitle: 'Błędne dane.',
        showError: true,
      });
    }
  }

  addGeomByPointIntersection = (idx, latlng) => {
    const coords = [latlng.lng, latlng.lat];
    const point1 = point(coords);

    let arr = _.cloneDeep(this.state.listMaterials);
    if (Object.keys(this.state.listMaterials[idx].materialGeoms).length !== 0) {
      for (const feature of this.state.listMaterials[idx].materialGeoms.features) {
        const poly2 = buffer(multiPolygon(feature.geometry.coordinates), 0);
        const intersection = intersect(poly2, point1);
        if (intersection) {
          const godlo = feature.properties.godlo;
          const skala = feature.properties.skala;
          const uklad = feature.properties.uklad;
          const idMaterialu = feature.properties.idMaterialu;
          const selectionGroup = 'Godło arkusza mapy';
          if (!arr[idx].selectionGroups.includes(selectionGroup)) {
            arr[idx].selectionGroups.push(selectionGroup);
          }
          if (this.geomExists(idx, godlo)) {
            arr = this.increaseMaterialCount(idx, godlo, arr);
          } else {
            let availableCount = this.getMaterialAvailability(idx, idMaterialu);
            arr[idx].selectedMaterialsList.push({
              type: 'Feature',
              properties: {
                name: godlo,
                count: (availableCount > 0) ? 1 : 0,
                idMaterialu,
                skala,
                uklad,
                selectionGroup,
              },
              geometry: feature.geometry,
            });
          }
          break;
        }
      }
    }

    this.setState({
      listMaterials: arr,
    });
  }

  getPolySelectionButton(idx) {
    return (
      <button
        type="submit-lg"
        className={'btn btn-success'}
        style={{ btnStyle }}
        onClick={() => this.addGeomByPolyIntersection(idx)}
      >
        Dodaj
    </button>
    );
  }

  getPolyVertexAddingButton(idx) {
    return (
      <button
        type="submit-lg"
        className={'btn btn-success'}
        style={{ btnStyle }}
        onClick={() => this.addPolyVertex(idx)}
      >
        +
    </button>
    );
  }

  addPolyVertex = (idx) => {
    this.setState(({ listMaterials }) => {
      listMaterials[idx].listPolygons.push({
        X: '',
        Y: '',
      });
      return { listMaterials }
    })
  }

  getSelectionButton(group, state, idx, timeout) {
    return (
      <button
        type="submit-lg"
        className={'btn btn-success'}
        style={{ btnStyle }}
        disabled={(!this.state.listMaterials[idx][state] || !this.state.listMaterials[idx].selectedMaterialName)}
        onClick={() => this.beginIntersection(group, state, idx, timeout)}
      >
        Dodaj
    </button>
    );
  }

  getShapefileSelectionButton(state, idx) {
    return (
      <button
        type="submit-lg"
        className={'btn btn-success'}
        style={{ btnStyle }}
        disabled={!this.state.listMaterials[idx][state].name}
        onClick={() => this.beginShapefileIntersection(idx)}
      >
        Dodaj
      </button>
    );
  }

  onChangeGodloSelect = (e, state, elem, index) => {
    const arr = _.cloneDeep(this.state[state]);
    arr[index][elem] = e.value;

    this.setState({
      [state]: arr,
    });
  };

  onChangeDistrictSelect = (e, state, elem, index) => {
    const arr = _.cloneDeep(this.state[state]);
    arr[index][elem] = e.value;

    if (elem === 'voivodeship') {
      for (const voiv of this.state.voivodeship) {
        if (voiv.voivodeship === e.value) {
          arr[index].voivodeshipTERYT = voiv.teryt;
          break;
        }
      }
    }
    if (elem === 'voivodeshipTERYT') {
      for (const voiv of this.state.voivodeship) {
        if (voiv.teryt === e.value) {
          arr[index].voivodeship = voiv.voivodeship;
          break;
        }
      }
    }

    if (elem === 'district') {
      for (const dist of this.state.allDistricts) {
        if (dist.district === e.value) {
          arr[index].districtTERYT = dist.teryt;
          break;
        }
      }
    }
    if (elem === 'districtTERYT') {
      for (const dist of this.state.allDistricts) {
        if (dist.teryt === e.value) {
          arr[index].district = dist.district;
          break;
        }
      }
    }

    if (elem === 'community') {
      for (const comm of arr[index].fetchedCommunities) {
        if (comm.community === e.value) {
          arr[index].communityTERYT = comm.teryt;
          break;
        }
      }
    }
    if (elem === 'communityTERYT') {
      for (const comm of arr[index].fetchedCommunities) {
        if (comm.teryt === e.value) {
          arr[index].community = comm.community;
          break;
        }
      }
    }

    if (elem === 'town') {
      for (const town of arr[index].fetchedTowns) {
        if (town.town === e.value) {
          arr[index].townTERYT = town.teryt;
          break;
        }
      }
    }
    if (elem === 'townTERYT') {
      for (const town of arr[index].fetchedTowns) {
        if (town.teryt === e.value) {
          arr[index].town = town.town;
          break;
        }
      }
    }

    let callback = null;
    if (['district', 'districtTERYT'].includes(elem)) {
      callback = (i) => this.beforeFetchCommunities(i);
    }
    if (['community', 'communityTERYT'].includes(elem)) {
      callback = (i) => this.fetchTowns(i);
    }

    if (callback) {
      this.setState({
        [state]: arr,
      }, () => callback(index));
    } else {
      this.setState({
        [state]: arr,
      });
    }

  };

  beforeFetchCommunities(idx) {
    const listMaterials = _.cloneDeep(this.state.listMaterials);
    listMaterials[idx].community = null;
    listMaterials[idx].communityTERYT = null;
    listMaterials[idx].town = null;
    listMaterials[idx].townTERYT = null;
    listMaterials[idx].townOptions = [];
    listMaterials[idx].townTERYTOptions = [];
    this.setState({ listMaterials }, () => this.fetchCommunities(idx));
  }

  getTownOptions = (idx) => {
    const listMaterials = _.cloneDeep(this.state.listMaterials);

    const options = [];
    for (const town of listMaterials[idx].fetchedTowns) {
      options.push(
        {
          label: town.town,
          value: town.town,
          state: 'town',
        });
    }
    listMaterials[idx].townOptions = options;
    this.setState({
      listMaterials,
    }, () => this.getTownTerytOptions(idx));
  }

  getTownTerytOptions = (idx) => {
    const listMaterials = _.cloneDeep(this.state.listMaterials);

    const options = [];
    for (const town of listMaterials[idx].fetchedTowns) {
      options.push(
        {
          label: town.teryt,
          value: town.teryt,
          state: 'townTERYT',
        });
    }
    listMaterials[idx].townTERYTOptions = options;
    this.setState({
      listMaterials,
    });
  }

  getCommunityOptions = (idx) => {
    const listMaterials = _.cloneDeep(this.state.listMaterials);

    const options = [];
    for (const comm of listMaterials[idx].fetchedCommunities) {
      options.push(
        {
          label: comm.community,
          value: comm.community,
          state: 'community',
        });
    }
    listMaterials[idx].communityOptions = options;
    this.setState({
      listMaterials,
    }, () => this.getCommunityTerytOptions(idx));
  }

  getCommunityTerytOptions = (idx) => {
    const listMaterials = _.cloneDeep(this.state.listMaterials);

    const options = [];
    for (const comm of listMaterials[idx].fetchedCommunities) {
      options.push(
        {
          label: comm.teryt,
          value: comm.teryt,
          state: 'communityTERYT',
        });
    }
    listMaterials[idx].communityTERYTOptions = options;
    this.setState({
      listMaterials,
    });
  }

  getGodloOptions = (idx) => {
    const options = [];
    if (Object.keys(this.state.listMaterials[idx].materialGeoms).length !== 0) {
      for (const feature of this.state.listMaterials[idx].materialGeoms.features) {
        options.push(
          {
            label: feature.properties.godlo,
            value: feature.properties.godlo,
            state: 'godlo',
          });
      }
    }
    return options;
  }

  addGeomByGodlo = (idx) => {
    const godlo = this.state.listMaterials[idx].godlo;
    let geom = null;
    let idMaterialu = null;
    let skala = null;
    let uklad = null;

    if (Object.keys(this.state.listMaterials[idx].materialGeoms).length !== 0) {
      for (const feature of this.state.listMaterials[idx].materialGeoms.features) {
        if (feature.properties.godlo === godlo) {
          geom = feature.geometry;
          idMaterialu = feature.properties.idMaterialu;
          skala = feature.properties.skala;
          uklad = feature.properties.uklad;
          break;
        }
      }
    }

    let arr = _.cloneDeep(this.state.listMaterials);
    const selectionGroup = 'Godło arkusza mapy';
    if (!arr[idx].selectionGroups.includes(selectionGroup)) {
      arr[idx].selectionGroups.push(selectionGroup);
    }
    if (this.geomExists(idx, godlo)) {
      arr = this.increaseMaterialCount(idx, godlo, arr);
    } else {
      let availableCount = this.getMaterialAvailability(idx, idMaterialu);
      arr[idx].selectedMaterialsList.push({
        type: 'Feature',
        properties: {
          name: godlo,
          count: (availableCount > 0) ? 1 : 0,
          idMaterialu,
          skala,
          uklad,
          selectionGroup,
        },
        geometry: geom,
      });
    }
    arr[idx].godlo = null;

    this.setState({
      listMaterials: arr,
    });
  }

  getMaterialAvailability = (idx, idMaterialu) => {
    const CURRENT_MATERIAL = this.state.listMaterials[idx];
    if (CURRENT_MATERIAL.sharingMethod !== printedSharingMethod) {
      return 1;
    }

    const availabilty = CURRENT_MATERIAL.printigAvailabilty;
    let key = CURRENT_MATERIAL.printedSharingMethod;
    if (key === polygraphicMethod) {
      key = CURRENT_MATERIAL.printedSharingMethodDetails;
    }

    let availableCount = 0;
    if (idMaterialu in availabilty) {
      if ([blackWhiteFormat, colorFormat].includes(key)) {
        const available = availabilty[idMaterialu][key];
        if (available) {
          availableCount = 1;
        }
      } else {
        availableCount = availabilty[idMaterialu][key];
      }
    }

    if (availableCount < 0) {
      availableCount = 0;
    }
    return availableCount;
  }

  preventFromTakingTooMany = (idx, material) => {
    let availableCount = this.getMaterialAvailability(idx, material.properties.idMaterialu);
    material.properties.count = (this.state.listMaterials[idx]
      .printedSharingMethod === polygraphicMethod)
    ? (material.properties.count > availableCount)
      ? availableCount
      : material.properties.count
    : (availableCount)
      ? (material.properties.count)
        ? material.properties.count
        : 1
      : 0;
  }

  increaseMaterialCount = (idx, name, arr) => {

    if (printedSharingMethods.includes(this.state.listMaterials[idx].sharingMethod)) {
      for (const material of arr[idx].selectedMaterialsList)
        if (name === material.properties.name) {
          material.properties.count = parseInt(material.properties.count) + 1;
          this.preventFromTakingTooMany(idx, material);
        }
    }

    return arr;
  }

  geomExists = (idx, name) => {
    let exists = false;

    for (const geom of this.state.listMaterials[idx].selectedMaterialsList)
      if (name === geom.properties.name) {
        exists = true;
      }

    return exists;
  }

  highlightRowAndGeom = (idx, val) => {
    const arr = _.cloneDeep(this.state.listMaterials);
    if (arr[idx].selectedMaterialsList.length !== 0) {
      for (const feature of arr[idx].selectedMaterialsList) {
        if (val.properties.name === feature.properties.name) {
          arr[idx].highlightedGeoms = [{
            type: 'Feature',
            properties: {
              name: val.properties.name,
              count: 1,
            },
            geometry: feature.geometry,
          }];
        }
      }
    }

    this.setState({
      listMaterials: arr,
    });
  }

  renderPrintedMaterialsListHeader = (idx) => {
    return (
      <div className="col-lg-12">
        <Col key={`selectedMaterials${idx}col1`} xs={4} sm={4} md={4}>
          <p><b>Wybrane obszary</b></p>
        </Col>
        <Col key={`selectedMaterials${idx}col2`} xs={2} sm={2} md={2}>
          <p><b>Liczba egzemplarzy</b></p>
        </Col>
        <Col key={`selectedMaterials${idx}col3`} xs={5} sm={5} md={5}>
          {/* <p><b>Komunikaty</b></p> */}
        </Col>
        <Col key={`selectedMaterials${idx}col4`} xs={1} sm={1} md={1} >
          <p><b>Usuń</b></p>
        </Col>
      </div>
    );
  }

  renderNonPrintedMaterialsListHeader = (idx) => {
    return (
      <div className="col-lg-12">
        <Col key={`selectedMaterials${idx}col1`} xs={4} sm={4} md={4}>
          <p><b>Wybrane obszary</b></p>
        </Col>
        <Col key={`selectedMaterials${idx}col2`} xs={2} sm={2} md={2}>
          {/* <p><b>Liczba egzemplarzy</b></p> */}
        </Col>
        <Col key={`selectedMaterials${idx}col3`} xs={5} sm={5} md={5}>
          {/* <p><b>Komunikaty</b></p> */}
        </Col>
        <Col key={`selectedMaterials${idx}col4`} xs={1} sm={1} md={1} >
          <p><b>Usuń</b></p>
        </Col>
      </div>
    );
  }

  renderDeletionButton = (idx) => {

    return (
      <div key={`DeletionButton_${idx}`} className="col-lg-12" style={{ marginBottom: '10px' }}>
        <Col key={`DeletionButton_${idx}_col1`} xs={10} sm={10} md={10} style={{ marginBottom: '10px' }} />
        <Col key={`DeletionButton_${idx}_col2`} xs={2} sm={2} md={2} style={{ marginBottom: '10px' }}>
          <button
            type="submit-lg"
            className={'btn btn-danger'}
            style={{ btnStyle }}
            onClick={() => this.removeSelectedMaterials(idx)}
          >
            Usuń wszystko
          </button>
        </Col>
      </div>
    );
  }

  renderSelectionGroups = (group, name, i, idx) => {
    const selectionGroup = [];

    for (const material of this.state.listMaterials[idx].selectedMaterialsList) {
      if (material.properties.selectionGroup === name) {
        selectionGroup.push(material);
      }
    }

    return (
      <div key={`selectionGroup_${i}_${idx}`} className="col-lg-12" style={{ marginBottom: '10px' }}>
        <Col key={`selectionGroup_${i}_${idx}_col1`} xs={11} sm={11} md={11} style={{ marginBottom: '10px' }}>
          {selectionGroup.length > 0 ? <p style={{ color: 'red' }}><b>{`${i + 1}. ${name}`}</b></p> : null}
        </Col>
        <Col key={`selectionGroup_${i}_${idx}_col2`} xs={1} sm={1} md={1} style={{ marginBottom: '10px' }}>
          {selectionGroup.length > 0 && name !== 'Godło arkusza mapy' ?
            <button
              type="submit-lg"
              className={'btn btn-danger'}
              style={{ btnStyle }}
              onClick={() => this.removeSelectionGroup(idx, name)}
            >
              Usuń
            </button> : null}
        </Col>
        {selectionGroup.map((value, subidx) => {
          return this.renderMaterialsList(group, idx, value, subidx);
        })
        }
      </div>
    );
  }

  renderMaterialsList = (group, idx, val, subidx) => {
    let div = null;
    if (this.state.listMaterials[idx].sharingMethod === printedSharingMethod) {
      div = this.renderPrintedMaterialsList(group, idx, val, subidx);
    } else {
      div = this.renderNonPrintedMaterialsList(idx, val, subidx);
    }

    return div;
  }

  renderPrintedMaterialsList = (group, idx, value, subidx) => {
    let availableCount = this.getMaterialAvailability(idx, value.properties.idMaterialu);
    return (
      <div
        key={`Printed${idx}_${subidx}}`}
        className="col-lg-12"
        style={(this.state.listMaterials[idx].highlightedGeoms.length > 0 && this.state.listMaterials[idx].highlightedGeoms[0].properties.name === value.properties.name) ? { backgroundColor: '#969696', marginLeft: '12px' } : { marginLeft: '12px' }}
        onMouseEnter={() => this.highlightRowAndGeom(idx, value)}
        onMouseLeave={() => this.removeHighlight(idx)}
      >
        <Col key={`selectedMaterialsList${idx}col1`} xs={4} sm={4} md={4}>
          <p style={labelStyle}><b>{`${subidx + 1}. ${value.properties.name}`}</b></p>
        </Col>
        <Col key={`selectedMaterialsList${idx}col2`} xs={2} sm={2} md={2}>
          <div style={{ textAlign: 'justify' }}>
            <input
              type="number"
              min="0"
              max={
                (this.state.listMaterials[idx].printedSharingMethod === polygraphicMethod)
                ? availableCount
                : (availableCount)
                  ? null
                  : 0
              }
              disabled={!printedSharingMethods.includes(this.state.listMaterials[idx].sharingMethod)}
              className="form-control"
              name={'count'}
              style={{
                width: '100%',
                borderColor:
                  Object.keys(this.state.errors).indexOf(`count${idx}`) > -1 &&
                    this.state.errors[`count${idx}`] !== null &&
                    this.state.errors[`count${idx}`].length > 0
                    ? 'red'
                    : '#ccc',
              }}
              value={value.properties.count}
              placeholder={'Wprowadź liczbę...'}
              onChange={(e) => this.onChangeSelectedMaterial(e, group, idx, 'selectedMaterialsList', subidx, 'count')}
            />

          </div>
        </Col>
        <Col key={`selectedMaterialsList${idx}col3`} xs={5} sm={5} md={5} >
          <span style={{ display: 'block', width: '125px' }}>
            {
              (availableCount)
              ? (this.state.listMaterials[idx].printedSharingMethod === polygraphicMethod)
                ? `z ${availableCount} dostępnych`
                : 'materiał dostępny'
              : 'materiał niedostępny'
            }
          </span>
          {/* RENDER ERROS IN SPAN */}
          {Object.keys(this.state.errors).indexOf(`count${idx}`) > -1 &&
            this.state.errors[`count${idx}`] !== null &&
            this.state.errors[`count${idx}`].length > 0
            ? this.state.errors[`count${idx}`].map((val, index) => (
              <span key={index} style={errorSpanStyle}>
                {val}
              </span>
            ))
            : null}
        </Col>
        <Col key={`selectedMaterialsList${idx}col4`} xs={1} sm={1} md={1} >
          {value.properties.selectionGroup === 'Godło arkusza mapy' ? <button
            type="submit-lg"
            className={'btn btn-danger'}
            style={{ btnStyle }}
            onClick={() => this.removeSelectedMaterial(idx, value.properties.name)}
          >
            Usuń
          </button> : null}
        </Col>
      </div>);
  }

  renderNonPrintedMaterialsList = (idx, value, subidx) => {
    return (
      <div
        key={`NonPrinted${idx}_${subidx}}`}
        className="col-lg-12"
        style={(this.state.listMaterials[idx].highlightedGeoms.length > 0 && this.state.listMaterials[idx].highlightedGeoms[0].properties.name === value.properties.name) ? { backgroundColor: '#969696', marginLeft: '12px' } : { marginLeft: '12px' }}
        onMouseEnter={() => this.highlightRowAndGeom(idx, value)}
        onMouseLeave={() => this.removeHighlight(idx)}
      >
        <Col key={`selectedMaterialsList${idx}col1`} xs={4} sm={4} md={4}>
          <p style={labelStyle}><b>{`${subidx + 1}. ${value.properties.name}`}</b></p>
        </Col>
        <Col key={`selectedMaterialsList${idx}col2`} xs={2} sm={2} md={2}>
        </Col>
        <Col key={`selectedMaterialsList${idx}col3`} xs={5} sm={5} md={5} />
        <Col key={`selectedMaterialsList${idx}col4`} xs={1} sm={1} md={1} >
          {value.properties.selectionGroup === 'Godło arkusza mapy' ? <button
            type="submit-lg"
            className={'btn btn-danger'}
            style={{ btnStyle }}
            onClick={() => this.removeSelectedMaterial(idx, value.properties.name)}
          >
            Usuń
          </button> : null}
        </Col>
      </div>);
  }

  getMaterialPanel = (group, idx) => {
    const info = 'Zmiana przedmiotu wniosku spowoduje usunięcie z listy wszystkich wybranych wcześniej obszarów. W celu wyboru kolejnego materiału kliknij przycisk "Dodaj kolejny materiał" znajdujący się na dole tej sekcji.';
    return (
      <GrayPanel title={`Materiał ${idx + 1}`} key={`material${idx + 1}`}>
        <p><b>1. Przedmiot wniosku:</b></p>
        <br />
        <div className="col-lg-12">
        <Col key={`materials${idx}col1`} xs={6} sm={6} md={6}>
            <p><b>Standardowe opracowania kartograficzne:</b></p>
            {this.renderMapRadioButtons(standardMaterialsOptions, group, 'selectedMaterialName', idx)}
            <br />
            <p><b>Kartograficzne opracowania tematyczne:</b></p>
            {this.renderMapRadioButtons(kartoMaterialsOptions, group, 'selectedMaterialName', idx)}
            <br />
            {this.state.otherKartoMaterialsOptions.length > 0 && <p><b>Kartograficzne opracowania tematyczne - inne:</b></p>}
            {this.state.otherKartoMaterialsOptions.length > 0 && this.renderMapRadioButtons(this.state.otherKartoMaterialsOptions, group, 'selectedMaterialName', idx)}
            <br />
          </Col>
          <Col key={`materials${idx}col2`} xs={6} sm={6} md={6}>
            <p><b>Niestandardowe opracowania topograficzne:</b></p>
            {this.renderMapRadioButtons(customMaterialsOptions, group, 'selectedMaterialName', idx)}
            <br />
            {this.state.otherCustomMaterialsOptions.length > 0 && <p><b>Niestandardowe opracowania topograficzne - inne:</b></p>}
            {this.state.otherCustomMaterialsOptions.length > 0 && this.renderMapRadioButtons(this.state.otherCustomMaterialsOptions, group, 'selectedMaterialName', idx)}
            <br />
            {this.state.otherMaterialsOptions.length > 0 && <p><b>Inne niewymienione:</b></p>}
            {this.state.otherMaterialsOptions.length > 0 && this.renderMapRadioButtons(this.state.otherMaterialsOptions, group, 'selectedMaterialName', idx)}
            <br />
          </Col>
        </div>
        <br />
        {this.state.listMaterials[idx].selectedMaterialName && <p style={{ color: 'red' }}><b>Uwaga:</b> {info}</p>}
        <p><b>2. Forma udostępnienia materiałów:</b></p>
        {this.renderMaterialRadioButtons(sharingMethodOptions, group, 'sharingMethod', idx)}
        {this.state[group][idx].sharingMethod === rasterSharingMethod ?
          <div style={{ marginLeft: '10px' }}>
            {this.renderRasterFormats(idx)}
          </div> :
          null
        }
        {!this.state.publicService ? this.renderMaterialRadioButtons(sharingMethodOptions2, group, 'sharingMethod', idx) : null}
        {this.state[group][idx].sharingMethod === printedSharingMethod ?
          <div style={{ marginLeft: '10px' }}>
            {this.renderMaterialRadioButtons(printedMethodsOptions, group, 'printedSharingMethod', idx)}
            {this.state[group][idx].printedSharingMethod === polygraphicMethod ?
              <div style={{ marginLeft: '10px' }}>
                {this.renderMaterialRadioButtons(printedMethodDetailsOptions, group, 'printedSharingMethodDetails', idx)}
                {reservationText}
              </div> :
              null
            }
          </div> :
          null
        }
        <br />
        <p><b>3.Dane identyfikujące obszar:</b></p>
        {this.state[group][idx].selectedMaterialName === 'mapa glebowo-rolnicza w skali 1:5 000' ?
          this.renderMaterialRadioButtons(areaSelectionOptions2, group, 'areaSelection', idx)
          :
          this.renderMaterialRadioButtons(areaSelectionOptions, group, 'areaSelection', idx)}
        <br />

        {this.state[group][idx].areaSelection === 'godło arkusza mapy' && this.getGodloSelect(group, 'godlo', idx)}
        {this.state[group][idx].areaSelection === 'jednostki podziału terytorialnego kraju' && this.getDistrictSelection(group, idx)}
        {this.state[group][idx].areaSelection === 'obszar określony w załączniku' && this.getFileSelection(idx)}
        {this.state[group][idx].areaSelection === 'współrzędne wielokąta (poligonu)' && this.getPolygonSelection(group, idx)}
        <div className="col-lg-12">
          <CustomizedMap
            id={`CustomizedMap_${idx}_${Math.random()}`}
            idx={idx}
            changeToGodlo={this.changeSelectionToGodlo}
            materialGeoms={this.state[group][idx].materialGeoms}
            selectedGeoms={this.state[group][idx].selectedMaterialsList}
            addGeomByPointIntersection={this.addGeomByPointIntersection}
            addGeomByRectangleIntersection={this.addGeomByRectangleIntersection}
            addGeomByDrawedPolyIntersection={this.addGeomByDrawedPolyIntersection}
            selectedMaterialName={this.state[group][idx].selectedMaterialName}
            highlightedGeoms={this.state[group][idx].highlightedGeoms}
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </div>
        {this.state.listMaterials[idx].sharingMethod === printedSharingMethod ?
        this.renderPrintedMaterialsListHeader(idx) :
        this.renderNonPrintedMaterialsListHeader(idx)}
        <div className={'col-lg-12'} style={this.state[group][idx].selectionGroups.length > 0 && this.state[group][idx].selectedMaterialsList.length > 4 ? { height: '200px', overflowY: 'scroll' } : {}}>
          {this.state[group][idx].selectedMaterialsList.length > 0 ? this.renderDeletionButton(idx) : null}
          {this.state[group][idx].selectionGroups.map((name, index) => {
            return this.renderSelectionGroups(group, name, index, idx);
          })}
        </div>

        <div className="col-lg-12">
          <br />
          <Col key={'removeMaterialcol1'} xs={10} sm={10} md={10} />
          <Col key={'removeMaterialcol2'} xs={2} sm={2} md={2} >
            <button
              type="submit-lg"
              className={'btn btn-danger'}
              style={{ btnStyle }}
              disabled={this.state.listMaterials.length === 1}
              onClick={() => this.removeMaterial(idx, 'listMaterials')}
            >
            Usuń materiał
          </button>
          </Col>
        </div>
      </GrayPanel>);
  }

  validateMaterialField = (group, field, index) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][index][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateListGroups = (group) => {
    const errors = {};
    let idx = 0;
    if (this.state[group]) {
      for (const obj of this.state[group]) {
        for (const i in Object.keys(obj)) {
          const field = Object.keys(obj)[i];
          const checks = this.validateTreeField(group, field, idx);
          errors[`${field}${idx}`] = checks;
        }
        idx += 1;
      }
    }
    return errors;
  };

  onHide = () => this.setState({ showError: false });

  onHideLoading = () => this.setState({ loading: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    const value = e.target.value;
    let printingDisabled = _.cloneDeep(this.state.printingDisabled);

    if (name === 'sharingReason' && freeSharingReasonValues.includes(value)) {
      printingDisabled = true;
    }
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: value,
        },
        printingDisabled,
      },
      () => {
        if (['deliveryAddress'].includes(name)) {
          this.updateDeliveryAddress();
        }
        this.validate(group, name)
      }
    );
  };

  onChangeDate = (e) => {
    const state = _.cloneDeep(this.state.public);
    state.okresUdostepnienia = e;

    this.setState({ public: state }, () => this.validate('public', 'okresUdostepnienia'));
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  changeContactData = () => this.setState({ contactAsUser: !this.state.contactAsUser }, () => this.onChangeContact());

  changeRasterFormats = (item, idx) => {
    const listMaterials = _.cloneDeep(this.state.listMaterials);
    const selectedRasterFormats = listMaterials[idx].selectedRasterFormats;
    if (!selectedRasterFormats.includes(item)) {
      selectedRasterFormats.push(item);
    } else {
      const index = selectedRasterFormats.indexOf(item);
      selectedRasterFormats.splice(index, 1);
    }
    this.setState({ listMaterials });
  }

  onChangeContact = () => {
    if (this.state.contactAsUser) {
      this.setState({
        contact: {
          firstName: this.state.personalData.FirstName,
          lastName: this.state.personalData.LastName,
          PhoneNumber: this.state.personalData.PhoneNumber,
          email: this.state.personalData.Email,
        },
      }, () => this.validate('contact'));
    } else {
      this.setState({
        contact: {
          firstName: null,
          lastName: null,
          PhoneNumber: null,
          email: null,
        },
      });
    }
  };

  onChangePersonalData = (state, value) => {
    const personalData = _.cloneDeep(this.state.personalData);
    personalData[state] = value;

    if (state === 'Email') {
      this.setState({ skipProfileChecking: false });
    }

    this.setState({personalData}, () => this.updateDeliveryAddress());
    this.validateContact(state);
  }

  validateContact = (state) => {
    this.validate('personalData', state);
    if (this.state.contactAsUser) {
      this.onChangeContact();
    }
  }

  validateField = (group, field) => {
    const checks = [];
    if (field === 'deliveryEmail' && this.state[group].deliveryMethod !== deliveryAddressEmail) {
      return checks;
    }
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      let errors = this.validateGroup(group);
      if (group === 'contact') {
        const personalErrors = this.validateGroup('personalData');
        errors = { ...errors, ...personalErrors };
      }
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['contact', 'sharing', 'delivery', 'personalData', 'public'];
      for (const g of grupy) {
        if (g === 'contact') {
          const contact = this.state.contact;
          if (contact.firstName !== null || contact.lastName !== null || contact.PhoneNumber !== null || contact.email !== null) {
            const contactErrors = this.validateGroup('contact');
            errors = { ...errors, ...contactErrors };
          }
        } else {
          const err = this.validateGroup(g);
          errors = { ...errors, ...err };
        }
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  onChangeRadioButtons = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      });
  };

  renderRadioButtons = (buttonsList, group, state) => {
    for (const button of buttonsList) {
      button.disabled = this.checkIfDeliveryRadioDisbled(button, state);
    }
    return (
      <div>
        {buttonsList.map((item, index) => (
          <div key={`radio${item}_${index}`} className="radio" style={{ marginBottom: '0px', marginTop: '0px' }}>
            <label
              // htmlFor={`radio${item}_${index}`}
              style={item.disabled ? { color: 'gray' } : null}
            >
              <input
                type="radio"
                value={item.value}
                name={state}
                checked={this.state[group][state] === item.value}
                onChange={e => this.onChange(e, group)}
                disabled={item.disabled}
              />
              <b>{`    ${item.label}`}<br /></b>
            </label>
          </div>
        ))}
      </div>);
  }

  renderRadioButtonsWithFactors = (buttonsList, group, state) => {
    for (const button of buttonsList) {
      button.disabled = this.checkIfDeliveryRadioDisbled(button, state);
    }
    return (
      buttonsList.map((item, index) => (
        <div key={`FactorButtons_${item}_${index}`} className="col-lg-12" style={{ marginLeft: '-30px', marginBottom: '0px', marginTop: '0px' }}>
          <Col key={`radio${item}_${index}_value`} xs={9} sm={9} md={9} style={{ textAlign: 'left', marginBottom: '0px', marginTop: '0px' }}>
            <div key={`radio${item}_${index}`} className="radio" style={{ marginBottom: '0px', marginTop: '0px' }}>
              <label
                // htmlFor={`radio${item}_${index}`}
                style={item.disabled ? { color: 'gray' } : null}
              >
                <input
                  type="radio"
                  value={item.value}
                  name={state}
                  checked={this.state[group][state] === item.value}
                  onChange={e => this.onChange(e, group)}
                  disabled={item.disabled}
                />
                <b>{`    ${item.label}`}<br /></b>
              </label>
            </div>
          </Col>
          <Col key={`radio${item}_${index}factor`} xs={3} sm={3} md={3} style={{ textAlign: 'center', marginBottom: '0px', marginTop: '0px' }}>
            <p><b>{Object.keys(this.state.mainFactors).indexOf(item.value) > -1 ? this.state.mainFactors[item.value].toFixed(2) : ''}</b></p>
          </Col>
        </div>
        )));
  }

  renderFreeSharingInfo = () => {
    return (
      <div>
        <br />
        <p><b>W celu uzyskania materiału nieodpłatnie w sekcji "Załączniki" dodaj skan dokumentu uprawniającego do nieodpłatnego udostępnienia materiałów!</b></p>
        <ol>
          <li>
            Dotyczy jednostek organizacyjnych wchodzących w skład systemu oświaty, o którym mowa w ustawie z dnia 14 grudnia 2016 r. – Prawo oświatowe (Dz. U. z 2020 r. poz. 910).
          </li>
            Dotyczy uczelni w rozumieniu ustawy z dnia 20 lipca 2018 r. – Prawo o szkolnictwie wyższym i nauce (Dz. U. z 2020 r. poz. 85, z późn. zm.).
          <li>
            Dotyczy podmiotów, o których mowa w art. 3 ust. 2 i 3 ustawy z dnia 24 kwietnia 2003 r. o działalności pożytku publicznego i o wolontariacie (Dz. U. z 2020 r. poz. 1057).
          </li>
          <li>
            Dotyczy:
            <br />
            1) podmiotów, o których mowa w art. 7 ust. 1 pkt 1, 2 i 4 – 7 ustawy z dnia 20 lipca 2018 r. – Prawo o szkolnictwie wyższym i nauce, oraz innych podmiotów posiadających siedzibę na terytorium Rzeczypospolitej Polskiej, będących organizacjami prowadzącymi badania i upowszechniającymi wiedzę w rozumieniu art. 2 pkt 83 rozporządzenia Komisji (UE) nr 651/2014 z dnia 17 czerwca 2014 r. uznającego niektóre rodzaje pomocy za zgodne z rynkiem wewnętrznym w zastosowaniu art. 107 i 108 Traktatu (Dz. Urz. UE L 187 z 26.06.2014, str. 1, z późn. zm.);
            <br />
            2) podmiotów, o których mowa w art. 3 ust. 2 i 3 ustawy z dnia 24 kwietnia 2003 r. o działalności pożytku publicznego i o wolontariacie.
          </li>
          <li>
            Dotyczy służb specjalnych w rozumieniu art. 11 ustawy z dnia 24 maja 2002 r. o Agencji Bezpieczeństwa Wewnętrznego oraz Agencji Wywiadu (Dz. U. z 2020 r. poz. 27).
          </li>
        </ol>
      </div>
    );
  }

  checkIfDeliveryRadioDisbled = (item, state) => {
    let disabled = false;

    if (state === 'deliveryMethod' && freeSharingReasonValues.includes(this.state.sharing.sharingReason) && !freeDeliverygMethodValues.includes(item.value)) {
      disabled = true;
      if (this.state.delivery.deliveryMethod === item.value) {
        const delivery = _.cloneDeep(this.state.delivery);
        delivery.deliveryMethod = null;
        this.setState({ delivery });
      }
    }

    if (state === 'deliveryMethod' && this.state.isPrintedSharingMethod && !printedDeliverygMethodValues.includes(item.value)) {
      disabled = true;
      if (this.state.delivery.deliveryMethod === item.value) {
        const delivery = _.cloneDeep(this.state.delivery);
        delivery.deliveryMethod = 'Odbiór osobisty';
        this.setState({ delivery });
      }
    }
    if (state === 'sharingReason' && this.state.isPrintedSharingMethod && freeSharingReasonValues.includes(item.value)) {
      disabled = true;
    }
    return disabled;
  }

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      info: {
        oznaczenie: 'oznaczenie',
        uwagi: 'uwagi',
      },
    });
  };

  prepareMaterialsList = () => {
    const list = [];
      for (const mat of this.state.listMaterials) {
        list.push(
          {
            selectedMaterialName: mat.selectedMaterialName,
            areaSelection: mat.areaSelection,
            selectedMaterialsList: mat.selectedMaterialsList,
            sharingMethod: mat.sharingMethod,
            selectedRasterFormats: mat.selectedRasterFormats,

            category: mat.category,
            printedSharingMethod: mat.printedSharingMethod,
            printedSharingMethodDetails: mat.printedSharingMethodDetails,
          },
        );
      }
    return list;
  };

  checkSelectedMaterials = () => {
    let error = false;

    for (const material of this.state.listMaterials) {
      if (material.selectedMaterialsList.length < 1) {
        error = true;
        break;
      }
    }
    return error;
  }

  checkSharingMethod = () => {
    let error = false;

    for (const material of this.state.listMaterials) {
      if (!material.sharingMethod) {
        error = true;
        break;
      }
    }
    return error;
  }

  checkRasterFormats = () => {
    let error = false;

    for (const material of this.state.listMaterials) {
      if (material.sharingMethod === rasterSharingMethod && material.selectedRasterFormats.length < 1) {
        error = true;
        break;
      }
    }
    return error;
  }

  checkPrintedFormats = () => {
    let error = false;

    for (const material of this.state.listMaterials) {
      if (material.sharingMethod === printedSharingMethod && !material.printedSharingMethod) {
        error = true;
        break;
      } else if (material.sharingMethod === printedSharingMethod && material.printedSharingMethod && material.printedSharingMethod === polygraphicMethod && !material.printedSharingMethodDetails) {
        error = true;
        break;
      }
    }
    return error;
  }

  checkPrintedCounts = () => {
    let error = false;

    for (const material of this.state.listMaterials) {
      if (material.sharingMethod === printedSharingMethod) {
        for (const mat of material.selectedMaterialsList) {
          if (mat.properties.count < 1) {
            error = true;
            break;
          }
        }
      }
    }

    return error;
  }

  onJobFinish = () => {
    if (this.props.serviceInfo.user.userType === 'local') {
      window.location.href = `/eservices/eserviceSummary/${this.state.jobId}`;
    } else {
      window.location.href = `/eservices/eserviceSummary/${this.state.jobId}?customerId=${this.props.query.customerId}`;
    }
  }

  onJobFailed = () => this.setState({
    isWorking: false,
    errorText: 'Wystąpił błąd po stronie serwera. Administrator portalu został poinformowany o zaistniałej sytuacji.',
    errorTitle: 'Tymczasowa niedostępność usługi.',
    showError: true,
    sendServiceData: false,
  });

  onJobSuccess = () => this.setState({
    isWorking: false,
    errorText: 'Twój roboczy wniosek został wysłany do operatora WODGiK.',
    errorTitle: 'Wysłano wniosek.',
    showError: true,
  });

  getJobStatus = () => {
    return fetch(`${process.env.API_URL}/pzgik_status?task_id=${this.state.pzgik_id ? this.state.pzgik_id : ''}&jobId=${this.state.jobId ? this.state.jobId : ''}&validated=${this.state.validated ? 1 : 0}`,
      {
        method: 'POST',
      })
    .then(r => r.json())
    .then(resp => {
      this.setState(
        {
          jobStatus: resp,
        },
        () => {
          if (resp.status === 'STARTED' || resp.status === 'PENDING' || resp.status === 'RETRY') {
            setTimeout(this.getJobStatus, 1000);
          }
          if (resp.status === 'SUCCESS') {
            this.onJobFinish();
          }
          if (resp.status === 'FAILURE' || resp.status === 'REVOKED') {
            this.onJobFailed();
          }
        });
    },
    );
  }

  getDocx = () => {
    this.setState({isWorking: false});
    let link = document.createElement('a');
    link.href = `${process.env.API_URL}/eservices/${this.props.prefix}/getDoc/${this.state.jobId}/${this.state.fileName}`;
    link.download = this.state.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  showModalAlert = () => {
    this.setState({
      showUserModal: !this.state.showUserModal,
    });
  }

  showHelp = () => {
    this.setState((prevState, props) => ({...prevState.items, showHelpModal: !prevState.showHelpModal, }))
  }

  skipProfileChecking = () => {
    this.setState({ skipProfileChecking: true, showUserModal: !this.state.showUserModal}, () => this.startService());
  }

  sendingModal = () => {
    return (
      <Modal show={this.state.showUserModal}>
        <Modal.Header className="bg-warning" closeButton={false}>
          <Modal.Title>Znaleziono wnioskodawcę</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <center>Podany wnioskodawca posiada Profil Zaufany.</center>
          <br /><br />
          <Button className="btn btn-warning pull-left" onClick={() => this.showModalAlert()}>Zmień dane wnioskodawcy</Button>
          <Button className="btn btn-warning pull-left" style={{ marginLeft: '200px' }} onClick={() => this.skipProfileChecking()}>Pomiń</Button>
          <Button className="btn btn-warning pull-right" href={process.env.LOGIN_ENDPOINT}>Zaloguj się</Button>
          <br /><br />
        </Modal.Body>
      </Modal>
    );
  }

  helpModal = () => {
    return (
      <Modal show={this.state.showHelpModal} dialogClassName="my-modal">
        <Modal.Header className="bg-warning" closeButton={false}>
          <Modal.Title>Pomoc</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe className='pdf' style={{ width:"100%", height:"1200px" }}  frameBorder="1" src={`https://docs.google.com/gview?url=${helpLinkDict[this.props.serviceInfo.eservice.shortName]}&embedded=true`}></iframe>
          <Button className="btn btn-warning pull-left" onClick={this.showHelp}>Zamknij</Button>
        </Modal.Body>
      </Modal>
    );
  }

  postValidation = async () => {
    if (!this.props.serviceInfo.eservice.requiresUserInfo && this.state.sendServiceData && !this.props.serviceInfo.user && this.state.personalData.Email && !this.state.skipProfileChecking) {
      const userFound = await this.checkEpuapUser();
      if (userFound) {
        this.showModalAlert();
        return;
      }
    }
    if (!this.state.publicService && !this.state.sharing.sharingReason) {
      this.setState({
        errorText: 'Nie wybrano celu wniosku.',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
      return;
    }

    if (!this.state.delivery.deliveryMethod) {
      this.setState({
        errorText: 'Nie wybrano sposobu udostępnienia materiału.',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
      return;
    }

    if (this.checkSelectedMaterials()) {
      this.setState({
        errorText: 'W przynajmniej jednym przedmiocie wniosku nie wybrano żadnego obszaru.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    if (this.checkSharingMethod()) {
      this.setState({
        errorText: 'W przynajmniej jednym przedmiocie wniosku nie wybrano formy udostępnienia materiału.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    if (this.checkRasterFormats()) {
      this.setState({
        errorText: 'W przynajmniej jednym przedmiocie wniosku nie wybrano żadnego formatu rastrowego.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    if (this.checkPrintedFormats()) {
      this.setState({
        errorText: 'W przynajmniej jednym przedmiocie wniosku nie wybrano szczegółów formy drukowanej.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    if (this.checkPrintedCounts()) {
      this.setState({
        errorText: 'W przypadku formy drukowanej liczba egzemplarzy musi być większa od 0.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    const hasFieldErrors = this.haseErrors();
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    if (freeSharingReasonValues.includes(this.state.sharing.sharingReason) && this.props.serviceInfo.eservice.shortName !== 'UdostepnienieMaterialowBezLogowania') {
      if (!this.state.attachments || this.state.attachments.length === 0) {
        this.setState({
          errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
          errorTitle: 'Brak załączników.',
          showError: true,
          loading: false,
        });
        return;
      }

      const hasEmptyAttachment = this.validateAttachmentsContent();
      if (hasEmptyAttachment) {
        this.setState({
          errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
          errorTitle: 'Pusty załącznik.',
          showError: true,
          loading: false,
        });
        return;
      }
    }

    if (this.props.serviceInfo.eservice.shortName !== 'UdostepnienieMaterialowPublicznych') {
      // sprawdzenie czy stan magazynowy materiałów drukowanych nie uległ zmianie
      const printErrors = await this.checkFinalPrintingAvailability();
      if (printErrors.length > 0) {
        const names = [];
        for (const mat of printErrors) {
          names.push(mat.emblem);
        }
        const namesText = names.join(', ');

        this.setState({
          errorText: <p>W momencie składania wniosku, został zmniejszony stan magazynowy map drukowanych o przedmiotowych godłach: <b>{namesText}</b>, proszę spróbować ponownie lub skontaktować się z ośrodkiem w celu złożenia zlecenia na arkusz mapy.</p>,
          errorTitle: 'Zmiana stanu magazynowego',
          showError: true,
          loading: false,
        });
        return;
      }
    }

    if (!hasFieldErrors) {
      this.setState({
        isWorking: true,
      }, () => this.runService());
    }
  };

  checkEpuapUser = () => {
    let found = false;
    return fetch(`${process.env.API_URL}/getEpuapCustomer/${this.state.personalData.Email}/`)
    .then(r => r.json())
    .then(resp => {
      found = resp.profile_found;
      return found;
    },
    );
  }

  runService = () => {
    const listMaterials = this.prepareMaterialsList();
    this.props
      .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
        listMaterials,
        contact: this.state.contact,
        sharing: this.state.sharing,
        delivery: this.state.delivery,
        info: this.state.info,
        user: this.props.serviceInfo.eservice.requiresUserInfo
          ? {...this.props.serviceInfo.user}
          : {...this.state.personalData},
        shortName: this.props.serviceInfo.eservice.shortName,
        urzad: this.props.districts[this.props.prefix],
        attachments: this.state.attachments,
        sendServiceData: this.state.sendServiceData,
        skipProfileChecking: this.state.skipProfileChecking,
        public: this.state.public,
      })
      .then(resp => {
        if (resp.status === 200) {
          // if (this.state.publicService) {
          //   window.location.href = `${this.nextStep}${resp.jobId}`;
          // }
          if (!this.props.serviceInfo.eservice.requiresUserInfo && this.state.sendServiceData) {
            this.setState({ jobId: resp.jobId, sendServiceData: false }, () => this.onJobSuccess());
            return;
          }
          if (!this.props.serviceInfo.eservice.requiresUserInfo) {
            this.setState({ jobId: resp.jobId, fileName: resp.fileName }, () => this.getDocx());
            return;
          }
          this.setState({ jobId: resp.jobId, pzgik_id: resp.pzgik_id, validated: resp.validated }, () => this.getJobStatus());
        } else if (resp.status === 400 && Object.keys(resp).includes('message')) {
          this.setState({
            isWorking: false,
            errorText: resp.message,
            errorTitle: 'Błąd',
            showError: true,
          });
        } else {
          this.onJobFailed();
        }
      })
      .catch((error) => {
        console.info(error);
      });
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const loadingBody =
    (<div style={{ height: '100px', ...this.state.style }}>
      <center>
        <img role="presentation" src={waiting} style={{ width: '150px', height: '150px' }} />
      </center>
      <center>
        <p>
          Proszę czekać. Trwa pobieranie danych.
        </p>
      </center>
    </div>);

    const loadingTitle = <p style={this.state.style}>Pobieranie danych...</p>;
    return (
      <div style={{ paddingTop: '20px' }}>
        <div className='col-xs-1 help-button'>
         <Button className="btn btn-primary pull-right" onClick={this.showHelp}>POMOC</Button>
        </div>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer
          userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : this.state.personalData}
          onChangePersonalData={this.onChangePersonalData}
          isDisabled={!!this.props.serviceInfo.user}
          errors={this.state.errors}
        />
        <GrayPanel
          title={'2. Osoba wyznaczona do kontaktu ze strony wnioskodawcy'}
        >
          <div className={s.subtitle}>
            <input
              id="contactCheckbox"
              name="isDefault"
              type="checkbox"
              value={this.state.contactAsUser}
              onChange={this.changeContactData}
              checked={this.state.contactAsUser}
            />
            <label htmlFor="contactCheckbox">&nbsp;&nbsp;Takie jak wnioskodawcy</label>
          </div>
          {this.state.contactAsUser ?
            <DecisionContainer
              title={''}
              data={this.state.contact}
              errors={this.state.errors}
              formDict={disabledContactDict}
              onChange={e => this.onChange(e, 'contact')}
            /> :
            <DecisionContainer
              title={''}
              data={this.state.contact}
              errors={this.state.errors}
              formDict={contactDict}
              onChange={e => this.onChange(e, 'contact')}
            /> }
        </GrayPanel>
        { this.state.publicService ?
          <DecisionContainer
            title={'Wskazanie zadania publicznego, którego wykonanie wymaga udostępnienia tych danych'}
            data={this.state.public}
            errors={this.state.errors}
            formDict={publicDict}
            onChange={e => this.onChange(e, 'public')}
            onChangeDate={e => this.onChangeDate(e)}
          >
            <br />
            <p><b>*</b> - dzień, do którego wnioskodawca może posługiwać się materiałem do celów wskazanych we wniosku</p>
          </DecisionContainer> : null
        }
        <DecisionContainer
          title={'3. Oznaczenie wniosku'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={infoDict}
          onChange={e => this.onChange(e, 'info')}
        >
          <br />
          <p><b>*</b> - pole nieobowiązkowe</p>
        </DecisionContainer>

        {!this.state.publicService ?
          <GrayPanel
            title={'4. Cel wniosku'}
          >
            <div className="col-lg-12" style={{ marginLeft: '-30px' }}>
              <Col key={'CelWnioskucol1'} xs={9} sm={9} md={9} style={{ textAlign: 'left' }}>
                <p><b>Udostępnienie odpłatne:</b></p>
              </Col>
              <Col key={'CelWnioskucol2'} xs={3} sm={3} md={3} style={{ textAlign: 'center' }}>
                <p><b>Współczynnik CL</b></p>
              </Col>
            </div>
            {this.renderRadioButtonsWithFactors(payableSharingReasonOptions, 'sharing', 'sharingReason')}
            < br />
            <p><b>Udostępnienie nieodpłatne w postaci elektronicznej:</b></p>
            {this.renderRadioButtons(freeSharingReasonOptions, 'sharing', 'sharingReason')}

            {freeSharingReasonValues.includes(this.state.sharing.sharingReason) ?
              this.renderFreeSharingInfo() : null}
          </GrayPanel> : null}

        <GrayPanel
          title={!this.state.publicService ? '5. Sposób udostępnienia materiałów:' : '4. Sposób udostępnienia materiałów:'}
        >
          <div className="col-lg-12" style={{ marginLeft: '-30px' }}>
            <Col key={'SposobWnioskucol1'} xs={9} sm={9} md={9} style={{ textAlign: 'left' }} />
            <Col key={'SposobWnioskucol2'} xs={3} sm={3} md={3} style={{ textAlign: 'center' }}>
              {!this.state.publicService ?
                <p><b>Współczynnik SU</b></p> : null}
            </Col>
          </div>
          { this.state.publicService ?
            this.renderRadioButtons(publicDeliverygMethodOptions, 'delivery', 'deliveryMethod')
          : this.renderRadioButtonsWithFactors(deliverygMethodOptions, 'delivery', 'deliveryMethod')}

          {this.state.delivery.deliveryMethod === selfPickup ?
            <div className="col-lg-12" style={{ marginLeft: '-30px' }}>
              <br /><br />
              <p><b>W przypadku odbioru osobistego:</b></p>
              <Col key={'userDevicecol1'} xs={9} sm={9} md={9} style={{ textAlign: 'left' }}>
                <input
                  id={'userDevice'}
                  name={'userDevice'}
                  type="checkbox"
                  disabled={this.checkIfCheckBoxDisbled()}
                  value={this.state.delivery.userDevice}
                  onChange={(e) => this.onChangeCheckbox(e, 'delivery', 'userDevice')}
                />
                <label htmlFor={'userDevice'} style={this.checkIfCheckBoxDisbled() ? { color: 'gray' } : null}>&nbsp;&nbsp;{userDeviceText}</label>
              </Col>
              <Col key={'userDevicecol2'} xs={3} sm={3} md={3} style={{ textAlign: 'center' }}>
                <p><b>{Object.keys(this.state.mainFactors).indexOf(userDeviceText) > -1 ? this.state.mainFactors[userDeviceText].toFixed(2) : ''}</b></p>
              </Col>
            </div>
          : null}

          {this.state.delivery.deliveryMethod === deliveryAddressEmail ?
            <div className="col-lg-12" style={{ marginLeft: '-30px' }}>
              <br /><br />
              <p><b>W przypadku wysyłki pod wskazany adres e-mail:</b></p>
              <br />
              <p><b>Adres email:</b></p>
              <input
                id={'deliveryEmail'}
                name={'deliveryEmail'}
                type="textarea"
                value={this.state.delivery.deliveryEmail}
                style={{
                  width: '100%',
                  borderColor:
                    Object.keys(this.state.errors).indexOf('deliveryEmail') > -1 &&
                      this.state.errors.deliveryEmail !== null &&
                      this.state.errors.deliveryEmail.length > 0
                      ? 'red'
                      : '#ccc',
                }}
                onChange={(e) => this.onChange(e, 'delivery')}
              />
              {/* RENDER ERROS IN SPAN */}
              {Object.keys(this.state.errors).indexOf('deliveryEmail') > -1 &&
                this.state.errors.deliveryEmail !== null &&
                this.state.errors.deliveryEmail.length > 0
                ? this.state.errors.deliveryEmail.map((val, index) => (
                  <span key={index} style={errorSpanStyle}>
                    {val}
                  </span>
                ))
                : null}
            </div>
            : null}

          {this.state.delivery.deliveryMethod === deliveryAddress ?
            <div className="col-lg-12" style={{ marginLeft: '-30px' }}>
              <br /><br />
              <p><b>W przypadku wysyłki pod wskazany adres:</b></p>
              <br />
              <GrayPanel title="Adres do wysyłki">
              {this.renderRadioButtons(deliveryAddressOptions, 'delivery', 'deliveryAddress')}

              <Row style={{ marginBottom: '5px' }}>
                <Col key={'deliveryAddressLeft1'} xs={9} sm={9} md={2} mdOffset={2}>
                  <label>miejscowość</label>
                </Col>
                <Col key={'deliveryAddressRight1'} xs={9} sm={9} md={6}>
                  <input
                    disabled={this.state.delivery.deliveryAddress !== deliveryAddressOtherOption}
                    id={'deliveryAddressCity'}
                    name={'deliveryAddressCity'}
                    type="text"
                    value={this.state.delivery.deliveryAddressCity}
                    style={{ width: '100%' }}
                    onChange={(e) => this.onChange(e, 'delivery')}
                  />
                </Col>
              </Row>
              <Row style={{ marginBottom: '5px' }}>
                <Col key={'deliveryAddressLeft2'} xs={9} sm={9} md={2} mdOffset={2}>
                  <label>ulica</label>
                </Col>
                <Col key={'deliveryAddressRight2'} xs={9} sm={9} md={6}>
                  <input
                    disabled={this.state.delivery.deliveryAddress !== deliveryAddressOtherOption}
                    id={'deliveryAddressStreet'}
                    name={'deliveryAddressStreet'}
                    type="text"
                    value={this.state.delivery.deliveryAddressStreet}
                    style={{ width: '100%' }}
                    onChange={(e) => this.onChange(e, 'delivery')}
                  />
                </Col>
              </Row>
              <Row style={{ marginBottom: '5px' }}>
                <Col key={'deliveryAddressLeft3'} xs={9} sm={9}  md={2} mdOffset={2}>
                  <label>nr budynku</label>
                </Col>
                <Col key={'deliveryAddressRight3'} xs={9} sm={9} md={6}>
                  <input
                    disabled={this.state.delivery.deliveryAddress !== deliveryAddressOtherOption}
                    id={'deliveryAddressNumber'}
                    name={'deliveryAddressNumber'}
                    type="text"
                    value={this.state.delivery.deliveryAddressNumber}
                    style={{ width: '100%' }}
                    onChange={(e) => this.onChange(e, 'delivery')}
                  />
                </Col>
              </Row>
              <Row style={{ marginBottom: '5px' }}>
                <Col key={'deliveryAddressLeft4'} xs={9} sm={9}  md={2} mdOffset={2}>
                  <label>nr lokalu</label>
                </Col>
                <Col key={'deliveryAddressRight4'} xs={9} sm={9} md={6}>
                  <input
                    disabled={this.state.delivery.deliveryAddress !== deliveryAddressOtherOption}
                    id={'deliveryAddressFlat'}
                    name={'deliveryAddressFlat'}
                    type="text"
                    value={this.state.delivery.deliveryAddressFlat}
                    style={{ width: '100%' }}
                    onChange={(e) => this.onChange(e, 'delivery')}
                  />
                </Col>
              </Row>
              <Row style={{ marginBottom: '5px' }}>
                <Col key={'deliveryAddressLeft5'} xs={9} sm={9}  md={2} mdOffset={2}>
                  <label>kod pocztowy</label>
                </Col>
                <Col key={'deliveryAddressRight5'} xs={9} sm={9} md={6}>
                  <input
                    disabled={this.state.delivery.deliveryAddress !== deliveryAddressOtherOption}
                    id={'deliveryAddressZipCode'}
                    name={'deliveryAddressZipCode'}
                    type="text"
                    value={this.state.delivery.deliveryAddressZipCode}
                    style={{ width: '100%' }}
                    onChange={(e) => this.onChange(e, 'delivery')}
                  />
                </Col>
              </Row>
              <Row style={{ marginBottom: '5px' }}>
                <Col key={'deliveryAddressLeft6'} xs={9} sm={9}  md={2} mdOffset={2}>
                  <label>poczta</label>
                </Col>
                <Col key={'deliveryAddressRight6'} xs={9} sm={9} md={6}>
                  <input
                    disabled={this.state.delivery.deliveryAddress !== deliveryAddressOtherOption}
                    id={'deliveryAddressMail'}
                    name={'deliveryAddressMail'}
                    type="text"
                    value={this.state.delivery.deliveryAddressMail}
                    style={{ width: '100%' }}
                    onChange={(e) => this.onChange(e, 'delivery')}
                  />
                </Col>
              </Row>
              </GrayPanel>
              <br /><br />

              <Col key={'userDevicecol1'} xs={9} sm={9} md={9} style={{ textAlign: 'left' }}>
                <input
                  id={'userDevice'}
                  name={'userDevice'}
                  type="checkbox"
                  disabled={this.checkIfCheckBoxDisbled()}
                  value={this.state.delivery.userDevice}
                  onChange={(e) => this.onChangeCheckbox(e, 'delivery', 'userDevice')}
                />
                <label htmlFor={'userDevice'} style={this.checkIfCheckBoxDisbled() ? { color: 'gray' } : null}>&nbsp;&nbsp;{userDeviceText}</label>
              </Col>
              <Col key={'userDevicecol2'} xs={3} sm={3} md={3} style={{ textAlign: 'center' }}>
                <p><b>{Object.keys(this.state.mainFactors).indexOf(userDeviceText) > -1 ? this.state.mainFactors[userDeviceText].toFixed(2) : ''}</b></p>
              </Col>
            </div>
          : null}
          {this.state.publicService ? null :
          <div className="col-lg-12" style={{ marginLeft: '-30px' }}>
            <br /><br />
            <p>
              Przy odbiorze osobistym lub wysyłce pod wskazany adres, gdy łączna wielkość udostępnionych danych elektronicznych nie przekracza 4 GB, koszt nośnika jest już uwzględniony w opłacie.
              W przypadku danych od 4 GB do 20 GB pobiera się opłatę ryczałtową w wysokości 5 zł za użycie nośników danych elektronicznych, chyba że wnioskodawca dostarczy nośnik danych.
              Dane powyżej 20 GB mogą być udostępniane po dostarczeniu przez wnioskodawcę odpowiedniego nośnika danych.
            </p>
          </div>}
        </GrayPanel>

        <GrayPanel title={this.state.publicService ? '5. Przedmiot wniosku' : '6. Przedmiot wniosku'}>
          {this.state.listMaterials.map((value, index) => {
            return (
            this.getMaterialPanel('listMaterials', index)
            );
          })}
          <div className="col-lg-12">
            <Col key={'addMaterialcol1'} xs={10} sm={10} md={10} />
            <Col key={'addMaterialcol2'} xs={2} sm={2} md={2} >
              <button
                type="submit-lg"
                className={'btn btn-success'}
                style={{ btnStyle }}
                onClick={() => this.addMaterial()}
              >
                Dodaj kolejny materiał
              </button>
            </Col>
          </div>
        </GrayPanel>

        <DecisionContainer
          title={this.state.publicService ? '6. Informacje dodatkowe' : '7. Informacje dodatkowe'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={infoDict2}
          onChange={e => this.onChange(e, 'info')}
        >
          <br />
          <p><b>*</b> - pole nieobowiązkowe</p>
        </DecisionContainer>

        {freeSharingReasonValues.includes(this.state.sharing.sharingReason) && this.props.serviceInfo.eservice.shortName !== 'UdostepnienieMaterialowBezLogowania' ?
          <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} /> : null}
        {freeSharingReasonValues.includes(this.state.sharing.sharingReason) && this.props.serviceInfo.eservice.shortName === 'UdostepnienieMaterialowBezLogowania' ?
          <GrayPanel
            title={'Załączniki'}
          >
            <p>Dokumenty uprawniające do nieodpłatnego udostępnienia danych prosimy przesłać na adres <b>{this.state.districtEmail}</b>, w tytule wpisać nazwę wybranego przedmiotu wniosku oraz zakres.</p>
          </GrayPanel> : null}
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        <ModalAlert
          title={loadingTitle}
          bodyText={loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHideLoading}
          disableButton
          removeCloseButton
          style={this.state.style}
        />
        <ModalAlert
          title={this.state.modalText}
          bodyText={this.state.modalBody}
          show={this.state.isWorking}
          name="isWorkingModal"
          onHide={this.onHide}
          disableButton
        />
        {this.state.showUserModal && this.sendingModal()}
        {this.state.showHelpModal && this.helpModal()}

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.startService()}
            >
            {
              this.props.serviceInfo.eservice.requiresUserInfo ? 'Uruchom' : 'Pobierz wniosek'
            }
            </button>

            {this.props.serviceInfo.user && _.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
        <div className="row mobile-row" style={{ marginTop: '10px' }}>
          <div className="col-sm-12">
            { !this.props.serviceInfo.eservice.requiresUserInfo ?
              <button
                type="submit-lg"
                className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={() => this.setState({ sendServiceData: true }, () => this.startService())}
              >
                Wyślij roboczy wniosek do Operatora WODGiK
              </button> : null }
          </div>
        </div>
      </div>
    );
  }
}

UdostepnienieMaterialow.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(UdostepnienieMaterialow),
);



// WEBPACK FOOTER //
// src/routes/eservices/UdostepnienieMaterialow.js